/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Composite key scalar type */
  CompositeKey: { input: any; output: any };
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: { input: any; output: any };
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: { input: any; output: any };
  /** A local date-time string (i.e., with no associated timezone) in `YYYY-MM-DDTHH:mm:ss` format, e.g. `2020-01-01T00:00:00`. */
  LocalDateTime: { input: any; output: any };
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: { input: any; output: any };
  /** Stock location id scalar type */
  LocationId: { input: any; output: any };
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any };
};

export type AccountProfileInput = {
  industry?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type Activity = {
  __typename?: 'Activity';
  /** Empty if the activity is not a message or assignee notes */
  comment?: Maybe<Comment>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** Empty if activity is not a job history entry (status change) */
  entry?: Maybe<JobHistory>;
  id: Scalars['ID']['output'];
  isFlagged: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  /** The job this activity is linked to */
  job?: Maybe<Job>;
  /** "status", "message", "notes", or "assigneeNotes" */
  kind: Scalars['String']['output'];
  tags?: Maybe<Array<Tag>>;
  /** The task this activity is linked to if job activity */
  task?: Maybe<Task>;
};

export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  edges: Array<ActivityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalUnreadCount: Scalars['Int']['output'];
};

export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  cursor: Scalars['String']['output'];
  node: Activity;
};

export type AddCommentInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  body: Scalars['String']['input'];
  jobId: Scalars['ID']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AddTagsToTaggableInput = {
  tagIds: Array<Scalars['ID']['input']>;
  taggableId: Scalars['ID']['input'];
};

export type Asset = Location & {
  __typename?: 'Asset';
  attachments: Array<Attachment>;
  attributes?: Maybe<Array<Attribute>>;
  /** The current deployment - always provided regardless of shareDeploymentHistory setting */
  deployment?: Maybe<Deployment>;
  /** Deployment history - filtered by shareDeploymentHistory permission for external users */
  deployments: Array<Deployment>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images: Array<Scalars['String']['output']>;
  jobs: Array<Job>;
  model?: Maybe<AssetModel>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  spaces: Array<Space>;
  status: Status;
  type: Scalars['String']['output'];
};

export type AssetAttributesArgs = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type AssetDeploymentsArgs = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type AssetJobsArgs = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type AssetInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  modelId?: InputMaybe<Scalars['Int']['input']>;
  /** Asset name or code */
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status: Status;
  type: Scalars['String']['input'];
};

export type AssetModel = {
  __typename?: 'AssetModel';
  activeAssets?: Maybe<Scalars['Int']['output']>;
  brand: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  status: Status;
  type: Scalars['String']['output'];
};

export type AssetModelInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  brand: Scalars['String']['input'];
  images: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status: Status;
  type: Scalars['String']['input'];
};

/** Tenant-level defaults for asset sharing configuration in job tasks */
export type AssetSharingDefaults = {
  __typename?: 'AssetSharingDefaults';
  /** Whether to share asset attributes (custom fields) with external assignees by default */
  shareAttributes: Scalars['Boolean']['output'];
  /** Whether to share deployment history for assets with external assignees by default */
  shareDeploymentHistory: Scalars['Boolean']['output'];
  /** Whether to share completed job history for assets with external assignees by default */
  shareJobHistory: Scalars['Boolean']['output'];
};

/** Input for updating tenant asset sharing defaults */
export type AssetSharingDefaultsInput = {
  /** Whether to share asset attributes (custom fields) with external assignees by default */
  shareAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to share deployment history for assets with external assignees by default */
  shareDeploymentHistory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to share completed job history for assets with external assignees by default */
  shareJobHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetTaskConfig = {
  __typename?: 'AssetTaskConfig';
  allow: Array<Scalars['String']['output']>;
  assetTypes: Array<Scalars['String']['output']>;
  selection: Scalars['String']['output'];
  shareAttributes: Scalars['Boolean']['output'];
  shareDeploymentHistory: Scalars['Boolean']['output'];
  /** Share completed jobs and their task messages */
  shareJobHistory: Scalars['Boolean']['output'];
  spaces: Array<Scalars['String']['output']>;
};

export type AssetTaskInput = {
  /** Possible values: "create", "edit" */
  allow?: InputMaybe<Array<Scalars['String']['input']>>;
  assetTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  assets?: InputMaybe<Array<Scalars['ID']['input']>>;
  deploy?: InputMaybe<Scalars['String']['input']>;
  /** Allowed values: "specific", "all" */
  selection: Scalars['String']['input'];
  shareAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  shareDeploymentHistory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Share completed jobs and their task messages */
  shareJobHistory?: InputMaybe<Scalars['Boolean']['input']>;
  spaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AssignJobsInput = {
  assigneeId?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  includeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobIds: Array<Scalars['ID']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<JobStatus>;
};

export type Attachment = {
  __typename?: 'Attachment';
  ext: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  thumb: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AttachmentInput = {
  id: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
};

export type Attribute = {
  __typename?: 'Attribute';
  attachments?: Maybe<Array<Attachment>>;
  category?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type AttributeInput = {
  name: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

export type AttributeInputV2 = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeSingle = {
  __typename?: 'AttributeSingle';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AttributeTask = {
  __typename?: 'AttributeTask';
  /** Attributes to include in the Attribute Task */
  attributes: Array<Scalars['String']['output']>;
  formValues?: Maybe<Array<Attribute>>;
  id: Scalars['ID']['output'];
};

export type AttributeTaskInput = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AttributeV2 = {
  __typename?: 'AttributeV2';
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Automation = {
  __typename?: 'Automation';
  assetIds?: Maybe<Array<Scalars['ID']['output']>>;
  assignees?: Maybe<Array<Contact>>;
  conditions?: Maybe<Array<AutomationCondition>>;
  day: Scalars['Int']['output'];
  do: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobName: Scalars['String']['output'];
  maintainRepeats?: Maybe<Scalars['Int']['output']>;
  matchAttribute?: Maybe<Array<Attribute>>;
  name: Scalars['String']['output'];
  on: Scalars['String']['output'];
  owners?: Maybe<Array<Contact>>;
  repeat?: Maybe<AutomationRepeat>;
  repeatStartDate?: Maybe<Scalars['DateTime']['output']>;
  repeatUntilOffset?: Maybe<Scalars['Int']['output']>;
  sites: Array<Site>;
  status: Status;
  template: JobTemplate;
  time?: Maybe<Scalars['String']['output']>;
  whereType: AutomationWhereType;
};

export type AutomationCondition = {
  __typename?: 'AutomationCondition';
  nights: Scalars['Int']['output'];
  operator: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AutomationInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignee?: InputMaybe<Array<Scalars['ID']['input']>>;
  day: Scalars['Int']['input'];
  jobName: Scalars['String']['input'];
  maintainRepeats?: InputMaybe<Scalars['Int']['input']>;
  matchAttribute?: InputMaybe<Array<AttributeInput>>;
  name: Scalars['String']['input'];
  on: Scalars['String']['input'];
  owner?: InputMaybe<Array<Scalars['ID']['input']>>;
  repeat?: InputMaybe<AutomationRepeatInput>;
  repeatStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  runOnExistingBookings: Scalars['Boolean']['input'];
  sites: Array<Scalars['ID']['input']>;
  status: Status;
  template: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
  whereType?: InputMaybe<AutomationWhereType>;
};

export type AutomationRepeat = {
  __typename?: 'AutomationRepeat';
  byday?: Maybe<Array<Scalars['String']['output']>>;
  bymonthday?: Maybe<Array<Scalars['String']['output']>>;
  freq: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  interval: Scalars['String']['output'];
};

export type AutomationRepeatInput = {
  byday?: InputMaybe<Array<Scalars['String']['input']>>;
  bymonthday?: InputMaybe<Scalars['String']['input']>;
  freq: Scalars['String']['input'];
  interval: Scalars['String']['input'];
};

export enum AutomationWhereType {
  All = 'All',
  Match = 'Match',
  Select = 'Select',
}

export type Booking = {
  __typename?: 'Booking';
  end: Scalars['LocalDateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  start: Scalars['LocalDateTime']['output'];
};

export type CalendarSubscription = {
  __typename?: 'CalendarSubscription';
  id: Scalars['ID']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type Card = ISpaceSku & {
  __typename?: 'Card';
  attributes: Array<Attribute>;
  capacity?: Maybe<Scalars['Int']['output']>;
  dispatched?: Maybe<Scalars['Int']['output']>;
  fill?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  packed?: Maybe<Scalars['Int']['output']>;
  pick?: Maybe<Scalars['Int']['output']>;
  picked?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  putAway?: Maybe<Scalars['Int']['output']>;
  queuedPrice?: Maybe<Scalars['Int']['output']>;
  queuedType?: Maybe<QueuedType>;
  received?: Maybe<Scalars['Int']['output']>;
  reorderLevel?: Maybe<Scalars['Int']['output']>;
  reserved: Scalars['Int']['output'];
  sku: Sku;
  skuId: Scalars['ID']['output'];
  soh: Scalars['Int']['output'];
  space: Space;
  spaceId: Scalars['ID']['output'];
  status: Status;
  stockTransferId?: Maybe<Scalars['ID']['output']>;
  target?: Maybe<Scalars['Int']['output']>;
};

export type ChangeEmailInput = {
  email: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ChecklistItem = {
  checked: Scalars['Boolean']['input'];
  key: Scalars['ID']['input'];
};

export type Comment = {
  __typename?: 'Comment';
  attachments?: Maybe<Array<Attachment>>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  isFlagged: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  tags?: Maybe<Array<Tag>>;
};

export type CompleteAttributeTaskInput = {
  attributes: Array<AttributeInput>;
  id: Scalars['ID']['input'];
};

export type CompleteItemTaskInput = {
  id: Scalars['ID']['input'];
  movements: Array<StockSelection>;
};

export type CompleteJobsInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  jobIds: Array<Scalars['ID']['input']>;
};

export type CompletePurchaseTaskInput = {
  adjustments: Array<StockSelection>;
  id: Scalars['ID']['input'];
};

export type CompleteTaskInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  attributes?: InputMaybe<Array<AttributeInputV2>>;
  checklist?: Array<ChecklistItem>;
  date: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  transfer?: InputMaybe<CompleteTransferTaskInput>;
};

export type CompleteTransferTaskInput = {
  selected: Array<StockSelection>;
};

export type Contact = Location & {
  __typename?: 'Contact';
  attributes: Array<Attribute>;
  createdAt: Scalars['DateTime']['output'];
  deployment?: Maybe<Deployment>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images: Array<Scalars['String']['output']>;
  isCurrentUser: Scalars['Boolean']['output'];
  isTeamMember: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Contact>;
  organisationId?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalAddress?: Maybe<Scalars['String']['output']>;
  relationship: Array<Scalars['String']['output']>;
  spaces: Array<Space>;
  status: Status;
  streetAddress?: Maybe<Scalars['String']['output']>;
  type: ContactType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  images?: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Array<Scalars['String']['input']>>;
  status: Status;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  type: ContactType;
};

export type ContactNavConfig = {
  __typename?: 'ContactNavConfig';
  isCustomized: Scalars['Boolean']['output'];
  navTypes: Array<Scalars['String']['output']>;
  showAllInNav: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ContactType {
  Organisation = 'Organisation',
  Person = 'Person',
}

export type ContactTypeMapping = {
  __typename?: 'ContactTypeMapping';
  label: Scalars['String']['output'];
  relationships: Array<Scalars['String']['output']>;
};

export type ContactTypeMappingInput = {
  label: Scalars['String']['input'];
  relationships: Array<Scalars['String']['input']>;
};

export type CreateJobInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignee?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /** Optional automation to link newly created jobs to (repeat automations only) */
  automationId?: InputMaybe<Scalars['ID']['input']>;
  /** A message to include with the notification */
  comment?: InputMaybe<Scalars['String']['input']>;
  createRepeatAutomation?: Scalars['Boolean']['input'];
  customer?: InputMaybe<Scalars['ID']['input']>;
  enforceOrder: Scalars['Boolean']['input'];
  fromTemplate?: InputMaybe<Scalars['String']['input']>;
  guestyCleaningStatus?: InputMaybe<Scalars['String']['input']>;
  /** List of contacts to share the job with */
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Site attributes to display */
  includeAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  includePdf?: InputMaybe<Scalars['Boolean']['input']>;
  /** Job attributes to collect */
  jobAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Array<Scalars['ID']['input']>>;
  repeat?: InputMaybe<RepeatInput>;
  saveTemplate?: InputMaybe<Scalars['String']['input']>;
  scheduledEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  scheduledEndStrict: Scalars['String']['input'];
  scheduledEndTime?: InputMaybe<Scalars['LocalTime']['input']>;
  scheduledStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  scheduledStartStrict: Scalars['String']['input'];
  scheduledStartTime?: InputMaybe<Scalars['LocalTime']['input']>;
  scope: CreateJobScope;
  scopeIds: Array<Scalars['ID']['input']>;
  sendMeACopy?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<JobStatus>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  tasks: Array<TaskInput>;
  timeZone: Scalars['String']['input'];
};

export enum CreateJobScope {
  Asset = 'Asset',
  Site = 'Site',
}

export type CreateTagInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type DeleteTagInput = {
  id: Scalars['ID']['input'];
};

export type Deployment = {
  __typename?: 'Deployment';
  asset: Asset;
  assetId: Scalars['ID']['output'];
  defaultSourceId?: Maybe<Scalars['ID']['output']>;
  displayLocation: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images: Array<Scalars['String']['output']>;
  location: Location;
  owner?: Maybe<Scalars['String']['output']>;
  space: Space;
  spaceId: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
  state?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type DeploymentDisplayLocationArgs = {
  separator?: Scalars['String']['input'];
};

export type Elsewhere = Location & {
  __typename?: 'Elsewhere';
  deployment?: Maybe<Deployment>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  spaces: Array<Space>;
};

export type FileInput = {
  form: Scalars['String']['input'];
  lastModified: Scalars['Timestamp']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type Filter = {
  field: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type Fsp = Location & {
  __typename?: 'Fsp';
  deployment?: Maybe<Deployment>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  spaces: Array<Space>;
};

export type HomheroArea = {
  __typename?: 'HomheroArea';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ISpaceSku = {
  attributes: Array<Attribute>;
  capacity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  queuedPrice?: Maybe<Scalars['Int']['output']>;
  queuedType?: Maybe<QueuedType>;
  reorderLevel?: Maybe<Scalars['Int']['output']>;
  reserved: Scalars['Int']['output'];
  sku: Sku;
  skuId: Scalars['ID']['output'];
  soh: Scalars['Int']['output'];
  space: Space;
  spaceId: Scalars['ID']['output'];
  status: Status;
  target?: Maybe<Scalars['Int']['output']>;
};

export type IndustryPreset = {
  __typename?: 'IndustryPreset';
  assetTypes: Array<Scalars['String']['output']>;
  siteTypes: Array<Scalars['String']['output']>;
};

/** An invitation to join a team */
export type Invitation = {
  __typename?: 'Invitation';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Item = {
  __typename?: 'Item';
  activeSkus: Scalars['Int']['output'];
  attributes?: Maybe<Array<Attribute>>;
  description?: Maybe<Scalars['String']['output']>;
  hasVariants: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  skuPrefix?: Maybe<Scalars['String']['output']>;
  skus: Array<Sku>;
  status: Status;
  type: ItemType;
  variantTypes: Array<VariantType>;
};

export type ItemInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasVariants: Scalars['Boolean']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Status>;
  type: ItemType;
  variants?: InputMaybe<Array<VariantInput>>;
};

export type ItemQty = {
  __typename?: 'ItemQty';
  id: Scalars['ID']['output'];
  qty: Scalars['Int']['output'];
};

export type ItemTask = {
  __typename?: 'ItemTask';
  cards: Array<Card>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<StockTransferItem>;
  spaceSkus: Array<SpaceSku>;
  status: JobStatus;
  stockTransfer: StockTransfer;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ItemTaskInput = {
  dispatch?: InputMaybe<Array<StockSelection>>;
  fillTo: StockTransferRule;
  /** Of the form `Type:id` */
  locationId: Scalars['ID']['input'];
  processQueuedChanges?: InputMaybe<Scalars['Boolean']['input']>;
  receive?: InputMaybe<Array<StockSelection>>;
  reserveStock?: InputMaybe<Scalars['Boolean']['input']>;
  selectStock: SelectStockOption;
  supplyJob: Scalars['Boolean']['input'];
};

export enum ItemType {
  Consumable = 'Consumable',
  Part = 'Part',
  Product = 'Product',
}

export type Job = {
  __typename?: 'Job';
  _dateCreated: Scalars['String']['output'];
  _dateScheduled?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use Job.assignees instead which correctly returns multiple assignees */
  assignee?: Maybe<Contact>;
  /** Notes added by the assignee when completing a job */
  assigneeNotes?: Maybe<Scalars['String']['output']>;
  assignees?: Maybe<Array<Contact>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Site attributes to display */
  attributes?: Maybe<Array<Attribute>>;
  booking?: Maybe<Booking>;
  /** @deprecated Front-end will compute this itself for offline support */
  canAcceptOffer: Scalars['Boolean']['output'];
  comments: Array<JobFeed>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Contact>;
  deploymentString?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['EmailAddress']['output']>;
  enforceOrder: Scalars['Boolean']['output'];
  guestyCleaningStatus?: Maybe<Scalars['String']['output']>;
  history: Array<JobHistory>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Array<Contact>>;
  isScheduled: Scalars['Boolean']['output'];
  isSource: Scalars['Boolean']['output'];
  /** Job attributes to collect */
  jobAttributeIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Job attributes to collect (saved values) */
  jobAttributes?: Maybe<Array<AttributeV2>>;
  jobNumber: Scalars['String']['output'];
  jobTags?: Maybe<Array<Tag>>;
  location?: Maybe<Location>;
  name: Scalars['String']['output'];
  nextCheckIn?: Maybe<Booking>;
  nodeId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** If the job location has a booking on the same date as this job, returns that booking, otherwise null */
  occupied?: Maybe<Booking>;
  /** @deprecated Account */
  owner: Organisation;
  owners?: Maybe<Array<Contact>>;
  permissions: Array<Scalars['String']['output']>;
  prevCheckOut?: Maybe<Booking>;
  scheduleEnd?: Maybe<Scalars['DateTime']['output']>;
  scheduleStart?: Maybe<Scalars['DateTime']['output']>;
  /** Scheduled end date localized */
  scheduledEndDate?: Maybe<Scalars['LocalDate']['output']>;
  scheduledEndStrict: Scalars['Boolean']['output'];
  /** Scheduled end time localized */
  scheduledEndTime?: Maybe<Scalars['LocalTime']['output']>;
  /** Scheduled start date localized */
  scheduledStartDate?: Maybe<Scalars['LocalDate']['output']>;
  scheduledStartStrict: Scalars['Boolean']['output'];
  /** Scheduled start time localized */
  scheduledStartTime?: Maybe<Scalars['LocalTime']['output']>;
  site?: Maybe<Site>;
  state?: Maybe<Scalars['String']['output']>;
  status: JobStatus;
  /** @deprecated Use jobTags instead */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tasks: Array<Task>;
  timeZone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type JobCommentsArgs = {
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type JobCalendarEvent = {
  __typename?: 'JobCalendarEvent';
  attributes?: Maybe<Array<Attribute>>;
  cancelled: Scalars['Boolean']['output'];
  /** @deprecated Use start instead */
  date: Scalars['DateTime']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  hidden: Scalars['Boolean']['output'];
  /** The name of an icon to use to help distinquish where the event came from */
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobs: Array<Job>;
  location?: Maybe<Location>;
  start: Scalars['DateTime']['output'];
  summary: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type JobFeed = Comment | JobHistory;

export type JobHistory = {
  __typename?: 'JobHistory';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Date entered by user if applicable */
  inputDate?: Maybe<Scalars['DateTime']['output']>;
  isFlagged: Scalars['Boolean']['output'];
  jobId: Scalars['ID']['output'];
  reverted: Scalars['Boolean']['output'];
  status: JobStatus;
  task?: Maybe<Task>;
  /** If not null this refers to task history */
  taskId?: Maybe<Scalars['ID']['output']>;
};

export type JobList = Job | JobCalendarEvent;

export enum JobStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  Created = 'Created',
  Declined = 'Declined',
  Deleted = 'Deleted',
  InProgress = 'InProgress',
  Incomplete = 'Incomplete',
  Offered = 'Offered',
  Paused = 'Paused',
}

export type JobTemplate = {
  __typename?: 'JobTemplate';
  attachments?: Maybe<Array<Attachment>>;
  behavior: TemplateBehavior;
  guestyCleaningStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includeAttributes?: Maybe<Array<Scalars['String']['output']>>;
  isStarter: Scalars['Boolean']['output'];
  jobAttributeIds?: Maybe<Array<Scalars['ID']['output']>>;
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quickCreate: Scalars['Boolean']['output'];
  status: Status;
  tags?: Maybe<Array<Tag>>;
  tasks: Array<Task>;
};

export type JobTemplateInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  behavior?: InputMaybe<TemplateBehavior>;
  guestyCleaningStatus?: InputMaybe<Scalars['String']['input']>;
  includeAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  jobAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quickCreate?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Status>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  tasks: Array<TaskInput>;
};

export type JobsConnection = {
  __typename?: 'JobsConnection';
  edges: Array<JobsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type JobsEdge = {
  __typename?: 'JobsEdge';
  cursor: Scalars['String']['output'];
  node: Job;
};

export type Location = {
  deployment?: Maybe<Deployment>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  spaces: Array<Space>;
};

export type LocationSelection = {
  id: Scalars['ID']['input'];
  spaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum LocationType {
  Asset = 'Asset',
  Contact = 'Contact',
  Site = 'Site',
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptJob?: Maybe<Job>;
  addComment: Comment;
  addItem: Item;
  addTagsToActivity: Activity;
  addTagsToJob: Array<Job>;
  addTagsToTaggable: Taggable;
  adjustStock: StockAdjustment;
  advanceTenantOnboardingStep?: Maybe<OnboardingFlow>;
  advanceUserOnboardingStep: UserOnboardingFlow;
  assignJobs?: Maybe<Array<Job>>;
  cancelJob?: Maybe<Job>;
  cancelJobs?: Maybe<Array<Job>>;
  changeEmailAddress: Scalars['Int']['output'];
  changePassword: Scalars['Int']['output'];
  /** completeAttributeTask v2 */
  completeAttributeAuditTask: Task;
  /** @deprecated See completeAttributeAuditTask which is a newer version of this */
  completeAttributeTask: Scalars['Int']['output'];
  completeCustomTask: Task;
  completeItemTask: Task;
  completeJob?: Maybe<Job>;
  completeJobs?: Maybe<Array<Job>>;
  completePurchaseTask: Scalars['Int']['output'];
  completeTenantOnboardingFlow: OnboardingFlow;
  createAsset: Asset;
  createAssetModel: AssetModel;
  createAutomation?: Maybe<Scalars['ID']['output']>;
  createContact?: Maybe<Contact>;
  createDeployment: Deployment;
  createJobTemplate: JobTemplate;
  createJobs: Array<Job>;
  createSite: Site;
  createSpace: Space;
  createTag: Tag;
  createTenant: Scalars['ID']['output'];
  /** @deprecated This is for the old S3 strategy. Use CloudFlare images uploader instead. */
  createUpload: Upload;
  declineJob?: Maybe<Job>;
  deleteJob: Scalars['Int']['output'];
  deleteJobTemplate: Scalars['Int']['output'];
  deleteTag: Scalars['Boolean']['output'];
  endTask?: Maybe<Task>;
  finishStocktake: Scalars['Int']['output'];
  flagMessage: Scalars['Boolean']['output'];
  generatePicks: Scalars['String']['output'];
  guestySetup?: Maybe<Scalars['String']['output']>;
  hideJobCalendarEvent: JobCalendarEvent;
  inviteUser: Invitation;
  login: Session;
  markAllAsRead: Scalars['Int']['output'];
  markAsRead: Scalars['Int']['output'];
  markAsReadV2: Activity;
  offerJob?: Maybe<Job>;
  otpGenerate: OtpGenerateResponse;
  otpVerify: OtpVerifyResponse;
  patchOrganisationProfile: Scalars['Int']['output'];
  pauseJob?: Maybe<Job>;
  pauseTask?: Maybe<Task>;
  quickAdd: SpaceSku;
  removeContactTypeMapping: Scalars['Boolean']['output'];
  removeTagsFromActivity: Activity;
  removeTagsFromJob: Array<Job>;
  removeTagsFromTaggable: Taggable;
  removeUser: Scalars['Boolean']['output'];
  renameAssetType: PlaceTypeConfig;
  renameContactType: PlaceTypeConfig;
  renamePlaceType: PlaceTypeConfig;
  rescheduleJob: Job;
  /** null and undefined are very important for this mutation */
  rescheduleJobs: Array<Job>;
  resetTaskStatus?: Maybe<Task>;
  reslySetup?: Maybe<Scalars['String']['output']>;
  resumeJob?: Maybe<Job>;
  resumeTask?: Maybe<Task>;
  revertJobStatus?: Maybe<Job>;
  saveNotificationPreferences: Scalars['Int']['output'];
  sendVerificationEmail: Scalars['Boolean']['output'];
  setContactTypeMappings: Array<ContactTypeMapping>;
  setProfilePic: User;
  sortJob: Scalars['Boolean']['output'];
  startJob?: Maybe<Job>;
  startTask?: Maybe<Task>;
  startTenantOnboardingFlow: OnboardingFlow;
  startUserOnboardingFlow: UserOnboardingFlow;
  updateAccountProfile: Scalars['Boolean']['output'];
  updateAsset: Asset;
  updateAssetModel: AssetModel;
  /** Update the default asset sharing configuration for new job tasks. Only the fields provided will be updated. */
  updateAssetSharingDefaults: AssetSharingDefaults;
  updateAssetTypeConfig: PlaceTypeConfig;
  updateAttributeValues: Array<Attribute>;
  updateAutomation?: Maybe<Scalars['ID']['output']>;
  updateContact?: Maybe<Contact>;
  updateContactNavConfig: ContactNavConfig;
  updateContactTypeConfig: PlaceTypeConfig;
  updateDeployment: Scalars['Int']['output'];
  updateItem: Item;
  updateJob: Job;
  /** Lightweight mutation to update only the job assignee notes field */
  updateJobAssigneeNotes?: Maybe<Job>;
  updateJobTemplate: JobTemplate;
  updateJobTemplates?: Maybe<Array<Job>>;
  updatePersonalInfo: Scalars['Int']['output'];
  updatePlaceTypeConfig: PlaceTypeConfig;
  updateSite: Site;
  updateSpace: Space;
  updateSpaceSku: SpaceSku;
  updateTag: Tag;
  /** Update sharing options for an Asset task */
  updateTaskSharingOptions?: Maybe<Task>;
  upsertContactTypeMapping: ContactTypeMapping;
};

export type MutationAcceptJobArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationAddCommentArgs = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<AddCommentInput>;
};

export type MutationAddItemArgs = {
  input: ItemInput;
};

export type MutationAddTagsToActivityArgs = {
  id: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};

export type MutationAddTagsToJobArgs = {
  id: Array<Scalars['ID']['input']>;
  tagIds: Array<Scalars['ID']['input']>;
};

export type MutationAddTagsToTaggableArgs = {
  input: AddTagsToTaggableInput;
};

export type MutationAdjustStockArgs = {
  input: StockAdjustmentInput;
};

export type MutationAdvanceTenantOnboardingStepArgs = {
  flowKey: Scalars['String']['input'];
  totalSteps: Scalars['Int']['input'];
};

export type MutationAdvanceUserOnboardingStepArgs = {
  flowKey: Scalars['String']['input'];
  totalSteps: Scalars['Int']['input'];
};

export type MutationAssignJobsArgs = {
  input: AssignJobsInput;
};

export type MutationCancelJobArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationCancelJobsArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

export type MutationChangeEmailAddressArgs = {
  input: ChangeEmailInput;
};

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};

export type MutationCompleteAttributeAuditTaskArgs = {
  input: CompleteAttributeTaskInput;
};

export type MutationCompleteAttributeTaskArgs = {
  input: CompleteAttributeTaskInput;
};

export type MutationCompleteCustomTaskArgs = {
  input: CompleteTaskInput;
};

export type MutationCompleteItemTaskArgs = {
  input: CompleteItemTaskInput;
};

export type MutationCompleteJobArgs = {
  attributes?: InputMaybe<Array<AttributeInputV2>>;
  endTime: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
};

export type MutationCompleteJobsArgs = {
  input: CompleteJobsInput;
};

export type MutationCompletePurchaseTaskArgs = {
  input: CompletePurchaseTaskInput;
};

export type MutationCompleteTenantOnboardingFlowArgs = {
  flowKey: Scalars['String']['input'];
  totalSteps: Scalars['Int']['input'];
};

export type MutationCreateAssetArgs = {
  input: AssetInput;
};

export type MutationCreateAssetModelArgs = {
  input: AssetModelInput;
};

export type MutationCreateAutomationArgs = {
  input: AutomationInput;
};

export type MutationCreateContactArgs = {
  input: ContactInput;
};

export type MutationCreateDeploymentArgs = {
  input: NewDeploymentInput;
};

export type MutationCreateJobTemplateArgs = {
  input: JobTemplateInput;
};

export type MutationCreateJobsArgs = {
  input: CreateJobInput;
};

export type MutationCreateSiteArgs = {
  input: SiteInput;
};

export type MutationCreateSpaceArgs = {
  input: SpaceInput;
  locationId: Scalars['LocationId']['input'];
};

export type MutationCreateTagArgs = {
  input: CreateTagInput;
};

export type MutationCreateTenantArgs = {
  input: AccountProfileInput;
};

export type MutationCreateUploadArgs = {
  file: FileInput;
};

export type MutationDeclineJobArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationDeleteJobArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteJobTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};

export type MutationEndTaskArgs = {
  endTime: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
};

export type MutationFinishStocktakeArgs = {
  input: StocktakeInput;
};

export type MutationFlagMessageArgs = {
  flagged: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationGeneratePicksArgs = {
  stockTransferId: Scalars['Int']['input'];
};

export type MutationGuestySetupArgs = {
  integrationToken: Scalars['String']['input'];
};

export type MutationHideJobCalendarEventArgs = {
  id: Scalars['ID']['input'];
};

export type MutationInviteUserArgs = {
  email: Scalars['String']['input'];
};

export type MutationMarkAllAsReadArgs = {
  before: Scalars['ID']['input'];
};

export type MutationMarkAsReadArgs = {
  id: Scalars['ID']['input'];
};

export type MutationMarkAsReadV2Args = {
  id: Scalars['ID']['input'];
};

export type MutationOfferJobArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationOtpGenerateArgs = {
  input: OtpGenerateInput;
};

export type MutationOtpVerifyArgs = {
  input: OtpVerifyInput;
};

export type MutationPatchOrganisationProfileArgs = {
  input: OrganisationProfileInput;
};

export type MutationPauseJobArgs = {
  id: Scalars['ID']['input'];
};

export type MutationPauseTaskArgs = {
  id: Scalars['ID']['input'];
  pauseTime: Scalars['DateTime']['input'];
};

export type MutationQuickAddArgs = {
  input: QuickAddInput;
};

export type MutationRemoveContactTypeMappingArgs = {
  label: Scalars['String']['input'];
};

export type MutationRemoveTagsFromActivityArgs = {
  id: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};

export type MutationRemoveTagsFromJobArgs = {
  id: Array<Scalars['ID']['input']>;
  tagIds: Array<Scalars['ID']['input']>;
};

export type MutationRemoveTagsFromTaggableArgs = {
  input: RemoveTagsFromTaggableInput;
};

export type MutationRemoveUserArgs = {
  email: Scalars['String']['input'];
};

export type MutationRenameAssetTypeArgs = {
  input: RenamePlaceTypeInput;
};

export type MutationRenameContactTypeArgs = {
  input: RenamePlaceTypeInput;
};

export type MutationRenamePlaceTypeArgs = {
  input: RenamePlaceTypeInput;
};

export type MutationRescheduleJobArgs = {
  input: RescheduleJobInput;
};

export type MutationRescheduleJobsArgs = {
  input: RescheduleJobsInput;
};

export type MutationResetTaskStatusArgs = {
  id: Scalars['ID']['input'];
};

export type MutationReslySetupArgs = {
  key: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
};

export type MutationResumeJobArgs = {
  id: Scalars['ID']['input'];
};

export type MutationResumeTaskArgs = {
  id: Scalars['ID']['input'];
  resumeTime: Scalars['DateTime']['input'];
};

export type MutationRevertJobStatusArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  currentStatus: JobStatus;
  id: Scalars['ID']['input'];
};

export type MutationSaveNotificationPreferencesArgs = {
  input: NotificationSettingInput;
};

export type MutationSetContactTypeMappingsArgs = {
  mappings: Array<ContactTypeMappingInput>;
};

export type MutationSetProfilePicArgs = {
  image: Scalars['String']['input'];
};

export type MutationSortJobArgs = {
  id: Scalars['ID']['input'];
  rel: Scalars['ID']['input'];
  sort: Scalars['String']['input'];
};

export type MutationStartJobArgs = {
  id: Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type MutationStartTaskArgs = {
  id: Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type MutationStartTenantOnboardingFlowArgs = {
  flowKey: Scalars['String']['input'];
};

export type MutationStartUserOnboardingFlowArgs = {
  flowKey: Scalars['String']['input'];
};

export type MutationUpdateAccountProfileArgs = {
  input: AccountProfileInput;
};

export type MutationUpdateAssetArgs = {
  id: Scalars['ID']['input'];
  input: AssetInput;
};

export type MutationUpdateAssetModelArgs = {
  id: Scalars['ID']['input'];
  input: AssetModelInput;
};

export type MutationUpdateAssetSharingDefaultsArgs = {
  input: AssetSharingDefaultsInput;
};

export type MutationUpdateAssetTypeConfigArgs = {
  input: UpdatePlaceTypeConfigInput;
};

export type MutationUpdateAttributeValuesArgs = {
  input: UpdateAttributeValuesInput;
};

export type MutationUpdateAutomationArgs = {
  id: Scalars['ID']['input'];
  input: AutomationInput;
};

export type MutationUpdateContactArgs = {
  id: Scalars['ID']['input'];
  input: ContactInput;
};

export type MutationUpdateContactNavConfigArgs = {
  input: UpdateContactNavConfigInput;
};

export type MutationUpdateContactTypeConfigArgs = {
  input: UpdatePlaceTypeConfigInput;
};

export type MutationUpdateDeploymentArgs = {
  id: Scalars['ID']['input'];
  images: Array<Scalars['String']['input']>;
};

export type MutationUpdateItemArgs = {
  id: Scalars['ID']['input'];
  input: ItemInput;
};

export type MutationUpdateJobArgs = {
  input: UpdateJobInput;
};

export type MutationUpdateJobAssigneeNotesArgs = {
  assigneeNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationUpdateJobTemplateArgs = {
  id: Scalars['ID']['input'];
  input: JobTemplateInput;
};

export type MutationUpdateJobTemplatesArgs = {
  jobIds: Array<Scalars['ID']['input']>;
  templateId: Scalars['ID']['input'];
};

export type MutationUpdatePersonalInfoArgs = {
  input: PersonalInfoInput;
};

export type MutationUpdatePlaceTypeConfigArgs = {
  input: UpdatePlaceTypeConfigInput;
};

export type MutationUpdateSiteArgs = {
  id: Scalars['ID']['input'];
  input: SiteInput;
};

export type MutationUpdateSpaceArgs = {
  id: Scalars['ID']['input'];
  input: SpaceInput;
};

export type MutationUpdateSpaceSkuArgs = {
  id: Scalars['ID']['input'];
  input: SpaceSkuInput;
};

export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};

export type MutationUpdateTaskSharingOptionsArgs = {
  input: UpdateTaskSharingOptionsInput;
};

export type MutationUpsertContactTypeMappingArgs = {
  mapping: ContactTypeMappingInput;
};

export type NewDeploymentInput = {
  assetId: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId: Scalars['LocationId']['input'];
  spaceName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type NotificationSettingInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last24Status?: InputMaybe<Scalars['String']['input']>;
  last24StatusEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  last24StatusRole?: InputMaybe<Scalars['String']['input']>;
  reminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reminderRole?: InputMaybe<Scalars['String']['input']>;
  reminderTiming?: InputMaybe<Scalars['String']['input']>;
  sendTimeZone?: InputMaybe<Scalars['String']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
  statusChange?: InputMaybe<Scalars['String']['input']>;
  statusEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  statusRole?: InputMaybe<Scalars['String']['input']>;
  summaryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  summaryRole?: InputMaybe<Scalars['String']['input']>;
  summarySendTime?: InputMaybe<Scalars['String']['input']>;
  summaryWindow?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingFlow = {
  __typename?: 'OnboardingFlow';
  completedAt?: Maybe<Scalars['String']['output']>;
  completedByUserId?: Maybe<Scalars['String']['output']>;
  currentStep?: Maybe<Scalars['Int']['output']>;
  flowKey: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
  startedByUserId?: Maybe<Scalars['String']['output']>;
};

export type Organisation = {
  __typename?: 'Organisation';
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type OrganisationProfileInput = {
  industry?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OtpGenerateInput = {
  identifier: Scalars['String']['input'];
  method?: InputMaybe<Scalars['String']['input']>;
};

export type OtpGenerateResponse = {
  __typename?: 'OtpGenerateResponse';
  id?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OtpVerifyInput = {
  id: Scalars['ID']['input'];
  otp: Scalars['String']['input'];
};

export type OtpVerifyResponse = {
  __typename?: 'OtpVerifyResponse';
  success: Scalars['Boolean']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['ID']['output']>;
};

export type PersonalInfoInput = {
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type PlaceTypeConfig = {
  __typename?: 'PlaceTypeConfig';
  isCustomized: Scalars['Boolean']['output'];
  navTypes: Array<Scalars['String']['output']>;
  orderMode: PlaceTypeOrderMode;
  showAllInNav: Scalars['Boolean']['output'];
  types: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PlaceTypeOrderMode {
  ALPHA = 'ALPHA',
  MANUAL = 'MANUAL',
}

export type PurchaseTask = {
  __typename?: 'PurchaseTask';
  id: Scalars['ID']['output'];
  movements?: Maybe<Array<PurchaseTaskItem>>;
  /** Space names to include in the Purchase Task */
  spaces: Array<Scalars['String']['output']>;
};

export type PurchaseTaskInput = {
  spaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PurchaseTaskItem = {
  __typename?: 'PurchaseTaskItem';
  id: Scalars['ID']['output'];
  qty: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** @deprecated Use tags (entityTypes: ["Activity"]) instead */
  activityTags: Array<Scalars['String']['output']>;
  addItemsTask: ItemTask;
  allActivity: ActivityConnection;
  allUsersOnboardingProgress: Array<UserOnboardingProgress>;
  asset?: Maybe<Asset>;
  assetModels: Array<AssetModel>;
  assetModelsFindByIds: Array<AssetModel>;
  /** Get the default asset sharing configuration for new job tasks. These defaults control what information external assignees can see by default. */
  assetSharingDefaults: AssetSharingDefaults;
  assetTypeConfig: PlaceTypeConfig;
  assetTypeCounts: Array<SiteTypeCount>;
  assetTypes: Array<Scalars['String']['output']>;
  assetTypesInUse: Array<Scalars['String']['output']>;
  assets: Array<Asset>;
  attributes: Array<Attribute>;
  automation?: Maybe<Automation>;
  automations: Array<Automation>;
  availableIndustries: Array<Scalars['String']['output']>;
  backgroundJob: Scalars['String']['output'];
  /** @deprecated This is for the old S3 strategy. Use CloudFlare images uploader instead. */
  baseUrl: Scalars['String']['output'];
  contact?: Maybe<Contact>;
  contactNavConfig: ContactNavConfig;
  contactTypeConfig: PlaceTypeConfig;
  contactTypeMappings: Array<ContactTypeMapping>;
  /** Contact relationships list for the tenant. If preset=true, returns preset relationships (that exist) in saved order; otherwise returns union of preset + in-use sorted alpha. */
  contactTypes: Array<Scalars['String']['output']>;
  /** Distinct contact relationships currently in use (excludes null/empty). */
  contactTypesInUse: Array<Scalars['String']['output']>;
  contacts: Array<Contact>;
  deployments: Array<Deployment>;
  fsps: Array<Fsp>;
  hasUntypedAssets: Scalars['Boolean']['output'];
  /** True if there are any contacts without a meaningful relationship. */
  hasUntypedContacts: Scalars['Boolean']['output'];
  /** True if there are any sites without a type (null). */
  hasUntypedSites: Scalars['Boolean']['output'];
  homheroAreas?: Maybe<Array<HomheroArea>>;
  inbox: Array<Thread>;
  industryPreset?: Maybe<IndustryPreset>;
  integrations: Array<Scalars['String']['output']>;
  isOnboardingFlowCompleted: Scalars['Boolean']['output'];
  items: Array<Item>;
  job?: Maybe<Job>;
  jobBoard: Array<JobList>;
  /** @deprecated Use jobBoard instead */
  jobCalendar: Array<JobCalendarEvent>;
  jobCalendarEvents: Array<JobCalendarEvent>;
  jobNameOptions: Array<Scalars['String']['output']>;
  /** @deprecated Use Query.tags instead */
  jobTags: Array<Scalars['String']['output']>;
  jobTemplates: Array<JobTemplate>;
  jobs: Array<Job>;
  location: Location;
  locations: Array<Location>;
  movementTypes: Array<Scalars['String']['output']>;
  placeTypeConfig: PlaceTypeConfig;
  session: Session;
  site: Site;
  siteTypeCounts: Array<SiteTypeCount>;
  siteTypes: Array<Scalars['String']['output']>;
  /** Distinct site types that currently exist for the tenant. Excludes null/empty. */
  siteTypesInUse: Array<Scalars['String']['output']>;
  sites: Array<Site>;
  /** Fetch all SKUs by given IDs otherwise all Active SKUs */
  skus: Array<Sku>;
  spaceNames: Array<Scalars['String']['output']>;
  spaceSkus: Array<SpaceSku>;
  spaces: Array<Space>;
  spacesConnection: SpaceConnection;
  stockAdjustmentTypes: Array<Scalars['String']['output']>;
  stockOnHand: Array<SpaceSku>;
  tags: TagConnection;
  task: Task;
  tenantOnboardingFlow?: Maybe<OnboardingFlow>;
  tenantOnboardingFlows: Array<OnboardingFlow>;
  userOnboardingFlow?: Maybe<UserOnboardingFlow>;
  users: Array<TenantUser>;
};

export type QueryAddItemsTaskArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAllActivityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  author?: InputMaybe<Array<Scalars['ID']['input']>>;
  commentTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<Scalars['String']['input']>;
  excludeAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  first?: Scalars['Int']['input'];
  flagged?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  jobTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationAttributes?: InputMaybe<Array<AttributeInput>>;
  query?: InputMaybe<Scalars['String']['input']>;
  showMessages?: InputMaybe<Scalars['Boolean']['input']>;
  showStatus?: InputMaybe<Scalars['Boolean']['input']>;
  showTaskNotes?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<Scalars['ID']['input']>>;
  tag?: InputMaybe<Array<Scalars['String']['input']>>;
  taskTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  unread?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAllUsersOnboardingProgressArgs = {
  flowKey: Scalars['String']['input'];
};

export type QueryAssetArgs = {
  id: Scalars['ID']['input'];
  jobId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAssetModelsFindByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryAssetTypesArgs = {
  preset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAssetsArgs = {
  status?: InputMaybe<Status>;
};

export type QueryAttributesArgs = {
  entityType: Scalars['String']['input'];
};

export type QueryAutomationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryBackgroundJobArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};

export type QueryContactTypesArgs = {
  preset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryContactsArgs = {
  relationship?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<Status>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryIndustryPresetArgs = {
  industry: Scalars['String']['input'];
};

export type QueryIsOnboardingFlowCompletedArgs = {
  flowKey: Scalars['String']['input'];
};

export type QueryItemsArgs = {
  inConfig?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<Status>>;
};

export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};

export type QueryJobBoardArgs = {
  asset?: Array<Scalars['ID']['input']>;
  assetType?: Array<Scalars['String']['input']>;
  assignee?: Array<Scalars['ID']['input']>;
  groupBy?: Scalars['String']['input'];
  included?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationAttributes?: Array<AttributeInput>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationName?: Array<Scalars['String']['input']>;
  locationOwnerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationType?: Array<Scalars['String']['input']>;
  ofType?: InputMaybe<Scalars['String']['input']>;
  scheduleFrom?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleTo?: InputMaybe<Scalars['DateTime']['input']>;
  scheduled?: InputMaybe<Scalars['String']['input']>;
  state?: Array<Scalars['String']['input']>;
  status?: Array<JobStatus>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryJobCalendarArgs = {
  locationName?: Array<Scalars['String']['input']>;
};

export type QueryJobCalendarEventsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryJobTemplatesArgs = {
  assetType?: InputMaybe<Scalars['String']['input']>;
  behavior?: InputMaybe<TemplateBehavior>;
  status?: InputMaybe<Status>;
};

export type QueryJobsArgs = {
  asset?: Array<Scalars['ID']['input']>;
  assetType?: Array<Scalars['String']['input']>;
  assignee?: Array<Scalars['ID']['input']>;
  groupBy?: Scalars['String']['input'];
  included?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationAttributes?: Array<AttributeInput>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationName?: Array<Scalars['String']['input']>;
  locationOwnerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationType?: Array<Scalars['String']['input']>;
  ofType?: InputMaybe<Scalars['String']['input']>;
  scheduleFrom?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleTo?: InputMaybe<Scalars['DateTime']['input']>;
  scheduled?: InputMaybe<Scalars['String']['input']>;
  state?: Array<Scalars['String']['input']>;
  status?: Array<JobStatus>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryLocationsArgs = {
  status?: InputMaybe<Status>;
  subtype?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<LocationType>;
};

export type QuerySiteArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySiteTypesArgs = {
  preset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySitesArgs = {
  excludingTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Status>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySkusArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QuerySpaceSkusArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QuerySpacesArgs = {
  id: Array<Scalars['ID']['input']>;
};

export type QuerySpacesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<Filter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryStockOnHandArgs = {
  filters?: InputMaybe<StockOnHandFilters>;
  location: Array<Scalars['LocationId']['input']>;
};

export type QueryTagsArgs = {
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTenantOnboardingFlowArgs = {
  flowKey: Scalars['String']['input'];
};

export type QueryUserOnboardingFlowArgs = {
  flowKey: Scalars['String']['input'];
};

export enum QueuedType {
  Add = 'Add',
  Remove = 'Remove',
}

export type QuickAddInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  itemName: Scalars['String']['input'];
  itemType: ItemType;
  location: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  reorderLevel?: InputMaybe<Scalars['Int']['input']>;
  skuCode?: InputMaybe<Scalars['String']['input']>;
  spaceName: Scalars['String']['input'];
  target?: InputMaybe<Scalars['Int']['input']>;
};

export type RemoveTagsFromTaggableInput = {
  tagIds: Array<Scalars['ID']['input']>;
  taggableId: Scalars['ID']['input'];
};

export type RenamePlaceTypeInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type RepeatInput = {
  byday?: InputMaybe<Array<Scalars['String']['input']>>;
  bymonthday?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  freq: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  until?: InputMaybe<Scalars['String']['input']>;
};

export type RescheduleJobInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  offsetDays?: InputMaybe<Scalars['Int']['input']>;
};

export type RescheduleJobsInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  endTime?: InputMaybe<Scalars['LocalTime']['input']>;
  jobIds: Array<Scalars['ID']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  startTime?: InputMaybe<Scalars['LocalTime']['input']>;
  status?: InputMaybe<JobStatus>;
};

export type Role = {
  __typename?: 'Role';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ScheduleEvent = {
  __typename?: 'ScheduleEvent';
  assignee?: Maybe<Contact>;
  /** @deprecated Use `assignee` instead */
  assignee_id?: Maybe<Scalars['ID']['output']>;
  attributes?: Maybe<Array<Attribute>>;
  days: Scalars['Float']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  included?: Maybe<Array<Contact>>;
  scheduledEndTime?: Maybe<Scalars['LocalTime']['output']>;
  scheduledStartTime?: Maybe<Scalars['LocalTime']['output']>;
  site_id: Scalars['ID']['output'];
  start: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** The timezone for this event. For user-generated events (jobs, bookings), this is resolved from the event, site, or tenant. For integration events, this is resolved from the site or tenant. Always returns a valid IANA timezone identifier. */
  timeZone: Scalars['String']['output'];
};

export type ScheduleFilters = {
  assignee?: InputMaybe<Array<Scalars['ID']['input']>>;
  included?: InputMaybe<Array<Scalars['ID']['input']>>;
  ofType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<JobStatus>>;
  tag?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The option selected for "select stock", the method to use when picking stock */
export enum SelectStockOption {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}

export type Session = {
  __typename?: 'Session';
  user: User;
};

export type Site = Location & {
  __typename?: 'Site';
  activeLocations: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  airbnbCalendar?: Maybe<Array<CalendarSubscription>>;
  airbnbDefaultCheckIn?: Maybe<Scalars['String']['output']>;
  airbnbDefaultCheckOut?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Array<Attribute>>;
  calendar: Array<ScheduleEvent>;
  calendarBounds: Array<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultSource?: Maybe<Site>;
  deployment?: Maybe<Deployment>;
  homhero?: Maybe<HomheroArea>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images: Array<Scalars['String']['output']>;
  integrationAttributes?: Maybe<Array<Attribute>>;
  jobs: JobsConnection;
  licensor?: Maybe<Organisation>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  spaces: Array<Space>;
  /** A shortcut for looking up state from site address */
  state?: Maybe<Scalars['String']['output']>;
  status: Status;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SiteAttributesArgs = {
  filter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteCalendarArgs = {
  filters?: InputMaybe<ScheduleFilters>;
};

export type SiteJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scheduled: Scalars['String']['input'];
};

export type SiteInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** List of calendar URLs to subscribe to */
  airbnbCalendar?: InputMaybe<Array<Scalars['String']['input']>>;
  airbnbDefaultCheckIn?: InputMaybe<Scalars['String']['input']>;
  airbnbDefaultCheckOut?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<AttributeInput>>;
  defaultSourceId?: InputMaybe<Scalars['ID']['input']>;
  homheroId?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  licensorId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status: Status;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SiteTypeCount = {
  __typename?: 'SiteTypeCount';
  count: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type Sku = {
  __typename?: 'Sku';
  _name?: Maybe<Scalars['String']['output']>;
  attributes: Array<AttributeSingle>;
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images: Array<Scalars['String']['output']>;
  item: Item;
  itemId: Scalars['ID']['output'];
  /** Short-cut for including item type without the full item */
  itemType: ItemType;
  name: Scalars['String']['output'];
  status: Status;
  variant: Array<VariantValue>;
};

export type Space = {
  __typename?: 'Space';
  activeSkus: Scalars['Int']['output'];
  attributes?: Maybe<Array<Attribute>>;
  createdAt: Scalars['DateTime']['output'];
  deployments: Array<Deployment>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images: Array<Scalars['String']['output']>;
  location: Location;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  skus: Array<SpaceSku>;
  status: Status;
  updatedAt: Scalars['DateTime']['output'];
};

export type SpaceSkusArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SpaceConnection = {
  __typename?: 'SpaceConnection';
  edges: Array<SpaceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SpaceEdge = {
  __typename?: 'SpaceEdge';
  cursor: Scalars['ID']['output'];
  node: Space;
};

export type SpaceInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  images: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status: Status;
};

export type SpaceSku = ISpaceSku & {
  __typename?: 'SpaceSku';
  attributes: Array<Attribute>;
  capacity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  queuedPrice?: Maybe<Scalars['Int']['output']>;
  queuedType?: Maybe<QueuedType>;
  reorderLevel?: Maybe<Scalars['Int']['output']>;
  reserved: Scalars['Int']['output'];
  sku: Sku;
  skuId: Scalars['ID']['output'];
  soh: Scalars['Int']['output'];
  space: Space;
  spaceId: Scalars['ID']['output'];
  status: Status;
  target?: Maybe<Scalars['Int']['output']>;
};

export type SpaceSkuInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  reorderLevel?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Scalars['Int']['input']>;
};

export enum Status {
  Active = 'Active',
  Inactive = 'Inactive',
}

export type StockAdjustment = {
  __typename?: 'StockAdjustment';
  id: Scalars['ID']['output'];
};

export type StockAdjustmentInput = {
  adjustments: Array<StockSelection>;
  date: Scalars['DateTime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type StockOnHandFilters = {
  itemAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  itemStatus?: InputMaybe<Array<Status>>;
  itemTypes?: InputMaybe<Array<ItemType>>;
  items?: InputMaybe<Array<Scalars['String']['input']>>;
  maxSoh?: InputMaybe<Scalars['Int']['input']>;
  minSoh?: InputMaybe<Scalars['Int']['input']>;
  spaceAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  spaces?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type StockSelection = {
  id: Scalars['CompositeKey']['input'];
  qty: Scalars['Int']['input'];
};

export type StockTransfer = Location & {
  __typename?: 'StockTransfer';
  deployment?: Maybe<Deployment>;
  destination: Location;
  /** A serialized string reference for destination location e.g. "Asset:123" */
  destinationString: Scalars['String']['output'];
  fsp: Fsp;
  id: Scalars['ID']['output'];
  items: Array<StockTransferItem>;
  name: Scalars['String']['output'];
  processQueuedChanges: Scalars['Boolean']['output'];
  rule: StockTransferRule;
  selectStock: SelectStockOption;
  source: Location;
  /** A serialized string reference for source location e.g. "Asset:123" */
  sourceString: Scalars['String']['output'];
  space: Space;
  spaces: Array<Space>;
  status: StockTransferStatus;
};

export type StockTransferItem = {
  __typename?: 'StockTransferItem';
  dispatched?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  packed?: Maybe<Scalars['Int']['output']>;
  pick: Scalars['Int']['output'];
  picked?: Maybe<Scalars['Int']['output']>;
  putAway?: Maybe<Scalars['Int']['output']>;
  received?: Maybe<Scalars['Int']['output']>;
  skuId: Scalars['ID']['output'];
  spaceId: Scalars['ID']['output'];
  stockTransferId: Scalars['ID']['output'];
};

export enum StockTransferRule {
  Capacity = 'Capacity',
  Target = 'Target',
}

export enum StockTransferStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Picked = 'Picked',
  Picking = 'Picking',
  Received = 'Received',
  Requested = 'Requested',
}

export type Stocktake = {
  __typename?: 'Stocktake';
  id: Scalars['ID']['output'];
  /** Item Types to include in the Stocktake */
  include: Array<ItemType>;
  /** Item Status to include in the Stocktake */
  itemStatus: Array<Status>;
  items: Array<StocktakeItem>;
  /** Space names to include in the Stocktake */
  spaces: Array<Scalars['String']['output']>;
};

export type StocktakeInput = {
  adjustments: Array<StockSelection>;
  date: Scalars['DateTime']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type StocktakeItem = {
  __typename?: 'StocktakeItem';
  adjustment: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  newOnHand: Scalars['Int']['output'];
  startOnHand: Scalars['Int']['output'];
};

export type StocktakeTaskInput = {
  include?: InputMaybe<Array<ItemType>>;
  itemStatus?: InputMaybe<Array<Status>>;
  spaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Tag = {
  __typename?: 'Tag';
  category?: Maybe<Scalars['String']['output']>;
  colour: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TagConnection = {
  __typename?: 'TagConnection';
  edges: Array<TagEdge>;
  nodes: Array<Tag>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TagEdge = {
  __typename?: 'TagEdge';
  cursor: Scalars['ID']['output'];
  node: Tag;
};

export type Taggable = {
  tags: TagConnection;
};

export type Task = Taggable & {
  __typename?: 'Task';
  assets: Array<Asset>;
  attachments?: Maybe<Array<Attachment>>;
  attribute?: Maybe<AttributeTask>;
  /** Site attributes to display on the task (for reading only) */
  attributes?: Maybe<Array<Attribute>>;
  config?: Maybe<AssetTaskConfig>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated See Task.attachments which will replace this */
  images?: Maybe<Array<Scalars['String']['output']>>;
  job: Job;
  jobAttributeIds?: Maybe<Array<Scalars['ID']['output']>>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  purchase?: Maybe<PurchaseTask>;
  required?: Maybe<Scalars['Boolean']['output']>;
  status: JobStatus;
  stockTransfer?: Maybe<StockTransfer>;
  stocktake?: Maybe<Stocktake>;
  tags: TagConnection;
  /** Job attributes to collect (saved values) */
  taskAttributes?: Maybe<Array<AttributeV2>>;
  transfer?: Maybe<TransferTask>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  asset?: InputMaybe<AssetTaskInput>;
  attribute?: InputMaybe<AttributeTaskInput>;
  /** ID of site attributes to display on the task */
  attributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  item?: InputMaybe<ItemTaskInput>;
  /** ID of job attributes to collect on the task */
  jobAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  purchase?: InputMaybe<PurchaseTaskInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  stocktake?: InputMaybe<StocktakeTaskInput>;
  /** IDs of tasks to set on this task */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  transfer?: InputMaybe<TransferTaskInput>;
  type: Scalars['String']['input'];
};

export enum TemplateBehavior {
  AssetRules = 'AssetRules',
  Static = 'Static',
}

export type TenantUser = Invitation | User;

export type Thread = {
  __typename?: 'Thread';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastAuthor: User;
  lastMessage: Scalars['String']['output'];
  lastUpdate: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};

export type TransferTask = {
  __typename?: 'TransferTask';
  available: Array<ItemQty>;
  moved: Array<ItemQty>;
  stockOnHand: Array<SpaceSku>;
};

export type TransferTaskInput = {
  from: LocationSelection;
  include?: InputMaybe<Array<ItemType>>;
  to: LocationSelection;
};

export type UpdateAttributeValuesInput = {
  attributes: Array<AttributeInputV2>;
  id: Scalars['ID']['input'];
};

export type UpdateContactNavConfigInput = {
  isCustomized?: InputMaybe<Scalars['Boolean']['input']>;
  navTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  showAllInNav?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateJobInput = {
  assignee?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /** A message to include with the notification */
  comment?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  enforceOrder?: InputMaybe<Scalars['Boolean']['input']>;
  guestyCleaningStatus?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  includePdf?: InputMaybe<Scalars['Boolean']['input']>;
  jobAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduledEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  scheduledEndStrict: Scalars['String']['input'];
  scheduledEndTime?: InputMaybe<Scalars['LocalTime']['input']>;
  scheduledStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  scheduledStartStrict: Scalars['String']['input'];
  scheduledStartTime?: InputMaybe<Scalars['LocalTime']['input']>;
  sendMeACopy?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<JobStatus>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  tasks: Array<TaskInput>;
};

export type UpdatePlaceTypeConfigInput = {
  isCustomized: Scalars['Boolean']['input'];
  navTypes: Array<Scalars['String']['input']>;
  orderMode: PlaceTypeOrderMode;
  showAllInNav: Scalars['Boolean']['input'];
  types: Array<Scalars['String']['input']>;
};

export type UpdateTagInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the tag to be updated */
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaskSharingOptionsInput = {
  /** Share asset attributes with external assignees */
  shareAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Share deployment history with external assignees */
  shareDeploymentHistory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Share completed jobs and their task messages */
  shareJobHistory?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['ID']['input'];
};

export type Upload = {
  __typename?: 'Upload';
  baseUrl: Scalars['String']['output'];
  ext: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  presignedUrl: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  attributes?: Maybe<Array<Attribute>>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images: Array<Scalars['String']['output']>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  roles: Array<Role>;
  status: Status;
};

export type UserOnboardingFlow = {
  __typename?: 'UserOnboardingFlow';
  completedAt?: Maybe<Scalars['String']['output']>;
  currentStep?: Maybe<Scalars['Int']['output']>;
  flowKey: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
};

export type UserOnboardingProgress = {
  __typename?: 'UserOnboardingProgress';
  completedAt?: Maybe<Scalars['String']['output']>;
  currentStep?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type VariantInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type VariantType = {
  __typename?: 'VariantType';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type VariantValue = {
  __typename?: 'VariantValue';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContactTypeConfig_CacheQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactTypeConfig_CacheQuery = {
  __typename?: 'Query';
  contactTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
    updatedAt: any;
  };
};

export type ScheduleEventStartEndFragment = {
  __typename?: 'ScheduleEvent';
  id: string;
  start: any;
  end?: any | null;
  timeZone: string;
} & { ' $fragmentName'?: 'ScheduleEventStartEndFragment' };

export type ScheduleEventTimesFragment = {
  __typename?: 'ScheduleEvent';
  id: string;
  start: any;
  end?: any | null;
  scheduledStartTime?: any | null;
  scheduledEndTime?: any | null;
  timeZone: string;
} & { ' $fragmentName'?: 'ScheduleEventTimesFragment' };

export type ScheduleEventStatusFragment = {
  __typename?: 'ScheduleEvent';
  id: string;
  status: string;
  timeZone: string;
} & { ' $fragmentName'?: 'ScheduleEventStatusFragment' };

export type ScheduleEventFullFragment = {
  __typename?: 'ScheduleEvent';
  id: string;
  summary: string;
  status: string;
  start: any;
  end?: any | null;
  scheduledStartTime?: any | null;
  scheduledEndTime?: any | null;
  timeZone: string;
  assignee?: {
    __typename?: 'Contact';
    id: string;
    name: string;
    image?: string | null;
  } | null;
} & { ' $fragmentName'?: 'ScheduleEventFullFragment' };

export type JobTimesFragment = {
  __typename?: 'Job';
  id: string;
  scheduleStart?: any | null;
  scheduleEnd?: any | null;
  scheduledStartDate?: any | null;
  scheduledStartTime?: any | null;
  scheduledEndDate?: any | null;
  scheduledEndTime?: any | null;
  scheduledStartStrict: boolean;
  scheduledEndStrict: boolean;
} & { ' $fragmentName'?: 'JobTimesFragment' };

export type DeploymentFieldsFragment = {
  __typename?: 'Deployment';
  id: string;
  displayLocation: string;
  startedAt: any;
  image?: string | null;
  location:
    | { __typename: 'Asset'; id: string; name: string }
    | { __typename: 'Contact'; id: string; name: string }
    | { __typename: 'Elsewhere'; id: string; name: string }
    | { __typename: 'Fsp'; id: string; name: string }
    | { __typename: 'Site'; id: string; name: string }
    | { __typename: 'StockTransfer'; id: string; name: string };
  space: { __typename?: 'Space'; id: string; name: string };
} & { ' $fragmentName'?: 'DeploymentFieldsFragment' };

export type AssetTypesQueryVariables = Exact<{ [key: string]: never }>;

export type AssetTypesQuery = {
  __typename?: 'Query';
  assetTypes: Array<string>;
};

export type SiteAttributesData_QueryQueryVariables = Exact<{
  entityType?: InputMaybe<Scalars['String']['input']>;
}>;

export type SiteAttributesData_QueryQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    GlobalAttributes_QueryFragmentFragment: GlobalAttributes_QueryFragmentFragment;
  };
};

export type GlobalAttributes_QueryFragmentFragment = {
  __typename?: 'Query';
  attributes: Array<
    { __typename?: 'Attribute'; id: string } & {
      ' $fragmentRefs'?: {
        Attribute_AttributeFragmentFragment: Attribute_AttributeFragmentFragment;
      };
    }
  >;
} & { ' $fragmentName'?: 'GlobalAttributes_QueryFragmentFragment' };

export type Attribute_AttributeFragmentFragment = {
  __typename?: 'Attribute';
  id: string;
  type: string;
  category?: string | null;
  name: string;
  value: Array<string>;
  condition?: string | null;
  options?: any | null;
  attachments?: Array<
    { __typename?: 'Attachment' } & {
      ' $fragmentRefs'?: {
        Attribute_AttachmentFragmentFragment: Attribute_AttachmentFragmentFragment;
      };
    }
  > | null;
} & { ' $fragmentName'?: 'Attribute_AttributeFragmentFragment' };

export type Attribute_AttachmentFragmentFragment = {
  __typename?: 'Attachment';
  id: string;
  kind: string;
  ext: string;
  thumb: string;
  url: string;
  originalFilename: string;
} & { ' $fragmentName'?: 'Attribute_AttachmentFragmentFragment' };

export type CreateContactMutationVariables = Exact<{
  input: ContactInput;
}>;

export type CreateContactMutation = {
  __typename?: 'Mutation';
  createContact?: {
    __typename?: 'Contact';
    id: string;
    status: Status;
    type: ContactType;
    name: string;
    email?: string | null;
    phone?: string | null;
    relationship: Array<string>;
    image?: string | null;
    isCurrentUser: boolean;
    isTeamMember: boolean;
  } | null;
};

export type ListSitesQueryVariables = Exact<{ [key: string]: never }>;

export type ListSitesQuery = {
  __typename?: 'Query';
  sites: Array<{
    __typename?: 'Site';
    id: string;
    status: Status;
    type?: string | null;
    name: string;
    address?: string | null;
    state?: string | null;
    image?: string | null;
    activeLocations: number;
    attributes?: Array<{
      __typename?: 'Attribute';
      id: string;
      type: string;
      category?: string | null;
      name: string;
      value: Array<string>;
    }> | null;
  }>;
};

export type RescheduleJobMutationVariables = Exact<{
  input: RescheduleJobInput;
}>;

export type RescheduleJobMutation = {
  __typename?: 'Mutation';
  rescheduleJob: {
    __typename?: 'Job';
    id: string;
    status: JobStatus;
    scheduleStart?: any | null;
    scheduleEnd?: any | null;
    scheduledStartStrict: boolean;
    scheduledStartDate?: any | null;
    scheduledStartTime?: any | null;
    scheduledEndStrict: boolean;
    scheduledEndDate?: any | null;
    scheduledEndTime?: any | null;
    completedAt?: any | null;
    permissions: Array<string>;
  };
};

export type TagFieldsFragment = {
  __typename?: 'Tag';
  id: string;
  entityType: string;
  name: string;
  category?: string | null;
  description?: string | null;
  colour: string;
} & { ' $fragmentName'?: 'TagFieldsFragment' };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;

export type CreateTagMutation = {
  __typename?: 'Mutation';
  createTag: { __typename?: 'Tag' } & {
    ' $fragmentRefs'?: { TagFieldsFragment: TagFieldsFragment };
  };
};

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;

export type UpdateTagMutation = {
  __typename?: 'Mutation';
  updateTag: { __typename?: 'Tag' } & {
    ' $fragmentRefs'?: { TagFieldsFragment: TagFieldsFragment };
  };
};

export type DeleteTagMutationVariables = Exact<{
  input: DeleteTagInput;
}>;

export type DeleteTagMutation = { __typename?: 'Mutation'; deleteTag: boolean };

export type ListTagsQueryVariables = Exact<{
  entityTypes?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type ListTagsQuery = {
  __typename?: 'Query';
  tags: {
    __typename?: 'TagConnection';
    edges: Array<{
      __typename?: 'TagEdge';
      node: {
        __typename?: 'Tag';
        id: string;
        entityType: string;
        name: string;
        category?: string | null;
        description?: string | null;
        colour: string;
      };
    }>;
  };
};

export type ActivityListItem_TagFragmentFragment = {
  __typename?: 'Tag';
  id: string;
  entityType: string;
  category?: string | null;
  name: string;
  description?: string | null;
  colour: string;
} & { ' $fragmentName'?: 'ActivityListItem_TagFragmentFragment' };

export type ActivityListItem_ActivityFragmentFragment = {
  __typename?: 'Activity';
  id: string;
  kind: string;
  createdAt: any;
  isRead: boolean;
  isFlagged: boolean;
  tags?: Array<
    { __typename?: 'Tag' } & {
      ' $fragmentRefs'?: {
        ActivityListItem_TagFragmentFragment: ActivityListItem_TagFragmentFragment;
      };
    }
  > | null;
  createdBy?: {
    __typename?: 'User';
    id: string;
    name: string;
    image?: string | null;
  } | null;
  job?: {
    __typename?: 'Job';
    id: string;
    name: string;
    site?: {
      __typename?: 'Site';
      id: string;
      name: string;
      image?: string | null;
      address?: string | null;
    } | null;
    jobTags?: Array<
      { __typename?: 'Tag' } & {
        ' $fragmentRefs'?: {
          ActivityListItem_TagFragmentFragment: ActivityListItem_TagFragmentFragment;
        };
      }
    > | null;
  } | null;
  task?: {
    __typename?: 'Task';
    id: string;
    name: string;
    notes?: string | null;
    tags: {
      __typename?: 'TagConnection';
      nodes: Array<
        { __typename?: 'Tag' } & {
          ' $fragmentRefs'?: {
            ActivityListItem_TagFragmentFragment: ActivityListItem_TagFragmentFragment;
          };
        }
      >;
    };
    attachments?: Array<{
      __typename?: 'Attachment';
      id: string;
      kind: string;
      thumb: string;
      url: string;
      originalFilename: string;
    }> | null;
  } | null;
  comment?: {
    __typename?: 'Comment';
    id: string;
    body?: string | null;
    attachments?: Array<{
      __typename?: 'Attachment';
      id: string;
      kind: string;
      thumb: string;
      url: string;
      originalFilename: string;
    }> | null;
    tags?: Array<
      { __typename?: 'Tag' } & {
        ' $fragmentRefs'?: {
          ActivityListItem_TagFragmentFragment: ActivityListItem_TagFragmentFragment;
        };
      }
    > | null;
  } | null;
  entry?: {
    __typename?: 'JobHistory';
    id: string;
    status: JobStatus;
    inputDate?: any | null;
  } | null;
} & { ' $fragmentName'?: 'ActivityListItem_ActivityFragmentFragment' };

export type FlagMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  flagged: Scalars['Boolean']['input'];
}>;

export type FlagMessageMutation = {
  __typename?: 'Mutation';
  flagMessage: boolean;
};

export type MarkAsReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type MarkAsReadMutation = {
  __typename?: 'Mutation';
  markAsRead: number;
};

export type MarkAllAsReadMutationVariables = Exact<{
  before: Scalars['ID']['input'];
}>;

export type MarkAllAsReadMutation = {
  __typename?: 'Mutation';
  markAllAsRead: number;
};

export type UpdateAttributeValuesMutationVariables = Exact<{
  input: UpdateAttributeValuesInput;
}>;

export type UpdateAttributeValuesMutation = {
  __typename?: 'Mutation';
  updateAttributeValues: Array<
    { __typename?: 'Attribute' } & {
      ' $fragmentRefs'?: { AttributeFieldsFragment: AttributeFieldsFragment };
    }
  >;
};

export type GetSiteForContextQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetSiteForContextQuery = {
  __typename?: 'Query';
  site: {
    __typename: 'Site';
    id: string;
    name: string;
    image?: string | null;
    status: Status;
    type?: string | null;
  };
};

export type AssetTypeConfigForFormQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AssetTypeConfigForFormQuery = {
  __typename?: 'Query';
  assetTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
    updatedAt: any;
  };
};

export type AssetRuleTemplatesQueryVariables = Exact<{
  behavior: TemplateBehavior;
}>;

export type AssetRuleTemplatesQuery = {
  __typename?: 'Query';
  jobTemplates: Array<{
    __typename?: 'JobTemplate';
    id: string;
    name: string;
    behavior: TemplateBehavior;
    quickCreate: boolean;
    tasks: Array<{
      __typename?: 'Task';
      id: string;
      config?: {
        __typename?: 'AssetTaskConfig';
        assetTypes: Array<string>;
      } | null;
    }>;
  }>;
};

export type AssetDeploymentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  jobId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AssetDeploymentsQuery = {
  __typename?: 'Query';
  asset?: {
    __typename?: 'Asset';
    id: string;
    deployments: Array<{
      __typename?: 'Deployment';
      id: string;
      status: Status;
      startedAt: any;
      image?: string | null;
      displayLocation: string;
    }>;
  } | null;
};

export type OtpGenerateMutationVariables = Exact<{
  input: OtpGenerateInput;
}>;

export type OtpGenerateMutation = {
  __typename?: 'Mutation';
  otpGenerate: {
    __typename?: 'OtpGenerateResponse';
    success: boolean;
    id?: string | null;
  };
};

export type OtpVerifyMutationVariables = Exact<{
  input: OtpVerifyInput;
}>;

export type OtpVerifyMutation = {
  __typename?: 'Mutation';
  otpVerify: { __typename?: 'OtpVerifyResponse'; success: boolean };
};

export type CreateJobTemplateMutationVariables = Exact<{
  input: JobTemplateInput;
}>;

export type CreateJobTemplateMutation = {
  __typename?: 'Mutation';
  createJobTemplate: { __typename?: 'JobTemplate'; id: string };
};

export type RescheduleJobsMutationVariables = Exact<{
  input: RescheduleJobsInput;
}>;

export type RescheduleJobsMutation = {
  __typename?: 'Mutation';
  rescheduleJobs: Array<{
    __typename?: 'Job';
    id: string;
    status: JobStatus;
    scheduleStart?: any | null;
    scheduleEnd?: any | null;
    scheduledStartStrict: boolean;
    scheduledStartDate?: any | null;
    scheduledStartTime?: any | null;
    scheduledEndStrict: boolean;
    scheduledEndDate?: any | null;
    scheduledEndTime?: any | null;
    completedAt?: any | null;
    permissions: Array<string>;
  }>;
};

export type ContactTypeMappingsForShortFormQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactTypeMappingsForShortFormQuery = {
  __typename?: 'Query';
  contactTypeMappings: Array<{
    __typename?: 'ContactTypeMapping';
    label: string;
    relationships: Array<string>;
  }>;
};

export type ContactTypeConfig_ForFormQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactTypeConfig_ForFormQuery = {
  __typename?: 'Query';
  contactTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
    updatedAt: any;
  };
};

export type ContactTypesPreset_ForFormQueryVariables = Exact<{
  preset?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ContactTypesPreset_ForFormQuery = {
  __typename?: 'Query';
  contactTypes: Array<string>;
};

export type ContactTypesInUse_ForFormQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactTypesInUse_ForFormQuery = {
  __typename?: 'Query';
  contactTypesInUse: Array<string>;
};

export type ContactTypeMappingsForFormQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactTypeMappingsForFormQuery = {
  __typename?: 'Query';
  contactTypeMappings: Array<{
    __typename?: 'ContactTypeMapping';
    label: string;
    relationships: Array<string>;
  }>;
};

export type AllContactsForTypes_FormQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllContactsForTypes_FormQuery = {
  __typename?: 'Query';
  contacts: Array<{
    __typename?: 'Contact';
    id: string;
    relationship: Array<string>;
  }>;
};

export type ContactTypeMappingsForListItemQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactTypeMappingsForListItemQuery = {
  __typename?: 'Query';
  contactTypeMappings: Array<{
    __typename?: 'ContactTypeMapping';
    label: string;
    relationships: Array<string>;
  }>;
};

export type ContactTypesPreset_ForListQueryVariables = Exact<{
  preset?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ContactTypesPreset_ForListQuery = {
  __typename?: 'Query';
  contactTypes: Array<string>;
};

export type ContactQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ContactQuery = {
  __typename?: 'Query';
  contact?: {
    __typename?: 'Contact';
    id: string;
    status: Status;
    type: ContactType;
    name: string;
    relationship: Array<string>;
    phone?: string | null;
    email?: string | null;
    streetAddress?: string | null;
    postalAddress?: string | null;
    notes?: string | null;
    image?: string | null;
    images: Array<string>;
    isCurrentUser: boolean;
    organisation?: { __typename?: 'Contact'; id: string; name: string } | null;
    attributes: Array<
      { __typename?: 'Attribute' } & {
        ' $fragmentRefs'?: { AttributeFieldsFragment: AttributeFieldsFragment };
      }
    >;
  } | null;
};

export type ContactTypeMappingsForViewQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactTypeMappingsForViewQuery = {
  __typename?: 'Query';
  contactTypeMappings: Array<{
    __typename?: 'ContactTypeMapping';
    label: string;
    relationships: Array<string>;
  }>;
};

export type AttributeSelectQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;

export type AttributeSelectQuery = {
  __typename?: 'Query';
  integrations: Array<string>;
  attributes: Array<{
    __typename?: 'Attribute';
    id: string;
    type: string;
    category?: string | null;
    name: string;
    condition?: string | null;
  }>;
};

export type AssignJobsMutationVariables = Exact<{
  input: AssignJobsInput;
}>;

export type AssignJobsMutation = {
  __typename?: 'Mutation';
  assignJobs?: Array<{
    __typename?: 'Job';
    id: string;
    status: JobStatus;
    permissions: Array<string>;
    owners?: Array<{
      __typename?: 'Contact';
      id: string;
      name: string;
      image?: string | null;
    }> | null;
    assignee?: {
      __typename?: 'Contact';
      id: string;
      name: string;
      image?: string | null;
    } | null;
    include?: Array<{
      __typename?: 'Contact';
      id: string;
      name: string;
      image?: string | null;
    }> | null;
  }> | null;
};

export type CancelJobsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type CancelJobsMutation = {
  __typename?: 'Mutation';
  cancelJobs?: Array<{
    __typename?: 'Job';
    id: string;
    status: JobStatus;
    permissions: Array<string>;
  }> | null;
};

export type CompleteJobsMutationVariables = Exact<{
  input: CompleteJobsInput;
}>;

export type CompleteJobsMutation = {
  __typename?: 'Mutation';
  completeJobs?: Array<{
    __typename?: 'Job';
    id: string;
    status: JobStatus;
    completedAt?: any | null;
    permissions: Array<string>;
  }> | null;
};

export type AddTagsToJobsMutationVariables = Exact<{
  jobIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AddTagsToJobsMutation = {
  __typename?: 'Mutation';
  addTagsToJob: Array<{
    __typename?: 'Job';
    id: string;
    jobTags?: Array<{ __typename?: 'Tag'; id: string }> | null;
  }>;
};

export type RemoveTagsFromJobsMutationVariables = Exact<{
  jobIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RemoveTagsFromJobsMutation = {
  __typename?: 'Mutation';
  removeTagsFromJob: Array<{
    __typename?: 'Job';
    id: string;
    jobTags?: Array<{ __typename?: 'Tag'; id: string }> | null;
  }>;
};

export type JobTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type JobTemplatesQuery = {
  __typename?: 'Query';
  jobTemplates: Array<{ __typename?: 'JobTemplate'; id: string; name: string }>;
};

export type UpdateJobTemplatesMutationVariables = Exact<{
  jobIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
}>;

export type UpdateJobTemplatesMutation = {
  __typename?: 'Mutation';
  updateJobTemplates?: Array<{ __typename?: 'Job'; id: string }> | null;
};

export type CreateJobsMutationVariables = Exact<{
  input: CreateJobInput;
}>;

export type CreateJobsMutation = {
  __typename?: 'Mutation';
  createJobs: Array<{
    __typename?: 'Job';
    id: string;
    status: JobStatus;
    name: string;
    createdAt: any;
    scheduledStartDate?: any | null;
    scheduledEndDate?: any | null;
    location?:
      | { __typename?: 'Asset'; id: string }
      | { __typename?: 'Contact'; id: string }
      | { __typename?: 'Elsewhere'; id: string }
      | { __typename?: 'Fsp'; id: string }
      | { __typename?: 'Site'; id: string }
      | { __typename?: 'StockTransfer'; id: string }
      | null;
  }>;
};

export type CreateAutomationMutationVariables = Exact<{
  input: AutomationInput;
}>;

export type CreateAutomationMutation = {
  __typename?: 'Mutation';
  createAutomation?: string | null;
};

export type AssetSharingDefaultsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AssetSharingDefaultsQuery = {
  __typename?: 'Query';
  assetSharingDefaults: {
    __typename?: 'AssetSharingDefaults';
    shareAttributes: boolean;
    shareJobHistory: boolean;
    shareDeploymentHistory: boolean;
  };
};

export type UpdateJobMutationVariables = Exact<{
  input: UpdateJobInput;
}>;

export type UpdateJobMutation = {
  __typename?: 'Mutation';
  updateJob: {
    __typename?: 'Job';
    id: string;
    status: JobStatus;
    name: string;
    notes?: string | null;
    scheduleStart?: any | null;
    scheduleEnd?: any | null;
    enforceOrder: boolean;
    updatedAt: any;
    attachments?: Array<
      { __typename?: 'Attachment' } & {
        ' $fragmentRefs'?: {
          AttachmentFieldsFragment: AttachmentFieldsFragment;
        };
      }
    > | null;
    assignee?: {
      __typename?: 'Contact';
      id: string;
      name: string;
      image?: string | null;
    } | null;
    customer?: { __typename?: 'Contact'; id: string; name: string } | null;
    tasks: Array<
      { __typename?: 'Task' } & {
        ' $fragmentRefs'?: { TaskDataFragment: TaskDataFragment };
      }
    >;
  };
};

export type HideJobCalendarEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type HideJobCalendarEventMutation = {
  __typename?: 'Mutation';
  hideJobCalendarEvent: {
    __typename?: 'JobCalendarEvent';
    id: string;
    hidden: boolean;
  };
};

export type JobCalendarEventFieldsFragment = {
  __typename?: 'JobCalendarEvent';
  id: string;
  start: any;
  end?: any | null;
  timeZone: string;
  summary: string;
  url?: string | null;
  icon?: string | null;
  cancelled: boolean;
  hidden: boolean;
  location?:
    | { __typename: 'Asset'; id: string; name: string }
    | { __typename: 'Contact'; id: string; name: string }
    | { __typename: 'Elsewhere'; id: string; name: string }
    | { __typename: 'Fsp'; id: string; name: string }
    | { __typename: 'Site'; id: string; name: string }
    | { __typename: 'StockTransfer'; id: string; name: string }
    | null;
  attributes?: Array<{
    __typename?: 'Attribute';
    name: string;
    value: Array<string>;
  }> | null;
  jobs: Array<{
    __typename: 'Job';
    id: string;
    status: JobStatus;
    name: string;
    createdAt: any;
    scheduleStart?: any | null;
    scheduleEnd?: any | null;
    scheduledStartStrict: boolean;
    scheduledStartDate?: any | null;
    scheduledStartTime?: any | null;
    scheduledEndStrict: boolean;
    scheduledEndDate?: any | null;
    scheduledEndTime?: any | null;
    completedAt?: any | null;
    timeZone: string;
    image?: string | null;
    tags?: Array<string> | null;
    location?:
      | { __typename: 'Asset'; id: string; name: string }
      | { __typename: 'Contact'; id: string; name: string }
      | { __typename: 'Elsewhere'; id: string; name: string }
      | { __typename: 'Fsp'; id: string; name: string }
      | { __typename: 'Site'; id: string; name: string }
      | { __typename: 'StockTransfer'; id: string; name: string }
      | null;
    assignee?: {
      __typename?: 'Contact';
      id: string;
      name: string;
      image?: string | null;
    } | null;
  }>;
} & { ' $fragmentName'?: 'JobCalendarEventFieldsFragment' };

export type CompleteJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  attributes: Array<AttributeInputV2> | AttributeInputV2;
}>;

export type CompleteJobMutation = {
  __typename?: 'Mutation';
  completeJob?: { __typename?: 'Job'; id: string; status: JobStatus } | null;
};

export type Feed_CommentFragment = {
  __typename?: 'Comment';
  id: string;
  body?: string | null;
  createdAt: any;
  isRead: boolean;
  isFlagged: boolean;
  createdBy?: { __typename?: 'User'; id: string; name: string } | null;
  attachments?: Array<{
    __typename?: 'Attachment';
    id: string;
    kind: string;
    thumb: string;
    url: string;
    originalFilename: string;
  }> | null;
  tags?: Array<{
    __typename?: 'Tag';
    id: string;
    entityType: string;
    category?: string | null;
    name: string;
    description?: string | null;
    colour: string;
  }> | null;
} & { ' $fragmentName'?: 'Feed_CommentFragment' };

export type FeedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FeedQuery = {
  __typename?: 'Query';
  job?: {
    __typename?: 'Job';
    id: string;
    status: JobStatus;
    comments: Array<
      | ({
          __typename: 'Comment';
          id: string;
          createdAt: any;
          createdBy?: {
            __typename?: 'User';
            id: string;
            name: string;
            image?: string | null;
          } | null;
          tags?: Array<{
            __typename?: 'Tag';
            id: string;
            entityType: string;
            category?: string | null;
            name: string;
            description?: string | null;
            colour: string;
          }> | null;
        } & {
          ' $fragmentRefs'?: { Feed_CommentFragment: Feed_CommentFragment };
        })
      | ({
          __typename: 'JobHistory';
          id: string;
          status: JobStatus;
          taskId?: string | null;
          createdAt: any;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            notes?: string | null;
            attachments?: Array<{
              __typename?: 'Attachment';
              id: string;
              kind: string;
              thumb: string;
              url: string;
              originalFilename: string;
            }> | null;
          } | null;
          createdBy?: {
            __typename?: 'User';
            id: string;
            name: string;
            image?: string | null;
          } | null;
        } & {
          ' $fragmentRefs'?: {
            Feed_JobHistoryFragment: Feed_JobHistoryFragment;
          };
        })
    >;
  } | null;
};

export type Feed_JobHistoryFragment = {
  __typename?: 'JobHistory';
  id: string;
  status: JobStatus;
  reverted: boolean;
  inputDate?: any | null;
  createdAt: any;
  task?: { __typename?: 'Task'; id: string; name: string } | null;
  createdBy?: {
    __typename?: 'User';
    id: string;
    image?: string | null;
    name: string;
  } | null;
} & { ' $fragmentName'?: 'Feed_JobHistoryFragment' };

export type AddCommentMutationVariables = Exact<{
  input: AddCommentInput;
}>;

export type AddCommentMutation = {
  __typename?: 'Mutation';
  addComment: {
    __typename?: 'Comment';
    id: string;
    body?: string | null;
    createdAt: any;
    attachments?: Array<{
      __typename?: 'Attachment';
      id: string;
      ext: string;
      url: string;
      originalFilename: string;
    }> | null;
    tags?: Array<{
      __typename?: 'Tag';
      id: string;
      entityType: string;
      category?: string | null;
      name: string;
      description?: string | null;
      colour: string;
    }> | null;
    createdBy?: { __typename?: 'User'; id: string; name: string } | null;
  };
};

export type RevertJobStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  currentStatus: JobStatus;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;

export type RevertJobStatusMutation = {
  __typename?: 'Mutation';
  revertJobStatus?: {
    __typename?: 'Job';
    id: string;
    status: JobStatus;
  } | null;
};

export type AddTagsToJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AddTagsToJobMutation = {
  __typename?: 'Mutation';
  addTagsToJob: Array<{
    __typename?: 'Job';
    id: string;
    jobTags?: Array<{ __typename?: 'Tag'; id: string }> | null;
  }>;
};

export type RemoveTagsFromJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RemoveTagsFromJobMutation = {
  __typename?: 'Mutation';
  removeTagsFromJob: Array<{
    __typename?: 'Job';
    id: string;
    jobTags?: Array<{ __typename?: 'Tag'; id: string }> | null;
  }>;
};

export type UpdateJobAssigneeNotesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  assigneeNotes?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateJobAssigneeNotesMutation = {
  __typename?: 'Mutation';
  updateJobAssigneeNotes?: {
    __typename?: 'Job';
    id: string;
    assigneeNotes?: string | null;
  } | null;
};

export type JobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type JobQuery = {
  __typename?: 'Query';
  job?: {
    __typename?: 'Job';
    id: string;
    status: JobStatus;
    jobNumber: string;
    name: string;
    scheduleStart?: any | null;
    scheduleEnd?: any | null;
    scheduledStartStrict: boolean;
    scheduledStartDate?: any | null;
    scheduledStartTime?: any | null;
    scheduledEndStrict: boolean;
    scheduledEndDate?: any | null;
    scheduledEndTime?: any | null;
    timeZone: string;
    completedAt?: any | null;
    jobAttributeIds?: Array<string> | null;
    notes?: string | null;
    assigneeNotes?: string | null;
    enforceOrder: boolean;
    isSource: boolean;
    permissions: Array<string>;
    canAcceptOffer: boolean;
    guestyCleaningStatus?: string | null;
    attributes?: Array<{
      __typename?: 'Attribute';
      id: string;
      type: string;
      category?: string | null;
      name: string;
      value: Array<string>;
      attachments?: Array<{
        __typename?: 'Attachment';
        id: string;
        kind: string;
        ext: string;
        thumb: string;
        url: string;
        originalFilename: string;
      }> | null;
    }> | null;
    jobAttributes?: Array<{
      __typename?: 'AttributeV2';
      id: string;
      value?: string | null;
    }> | null;
    jobTags?: Array<{
      __typename?: 'Tag';
      id: string;
      entityType: string;
      name: string;
      category?: string | null;
      description?: string | null;
      colour: string;
    }> | null;
    attachments?: Array<{
      __typename?: 'Attachment';
      id: string;
      kind: string;
      ext: string;
      thumb: string;
      url: string;
      originalFilename: string;
    }> | null;
    assignees?: Array<{
      __typename?: 'Contact';
      id: string;
      name: string;
      email?: string | null;
    }> | null;
    include?: Array<{
      __typename?: 'Contact';
      id: string;
      name: string;
      email?: string | null;
    }> | null;
    owners?: Array<{
      __typename?: 'Contact';
      id: string;
      name: string;
      email?: string | null;
    }> | null;
    customer?: { __typename?: 'Contact'; id: string; name: string } | null;
    location?:
      | {
          __typename: 'Asset';
          id: string;
          name: string;
          deployment?: {
            __typename?: 'Deployment';
            id: string;
            displayLocation: string;
          } | null;
        }
      | {
          __typename: 'Contact';
          id: string;
          name: string;
          deployment?: {
            __typename?: 'Deployment';
            id: string;
            displayLocation: string;
          } | null;
        }
      | {
          __typename: 'Elsewhere';
          id: string;
          name: string;
          deployment?: {
            __typename?: 'Deployment';
            id: string;
            displayLocation: string;
          } | null;
        }
      | {
          __typename: 'Fsp';
          id: string;
          name: string;
          deployment?: {
            __typename?: 'Deployment';
            id: string;
            displayLocation: string;
          } | null;
        }
      | {
          __typename: 'Site';
          address?: string | null;
          id: string;
          name: string;
          deployment?: {
            __typename?: 'Deployment';
            id: string;
            displayLocation: string;
          } | null;
        }
      | {
          __typename: 'StockTransfer';
          id: string;
          name: string;
          deployment?: {
            __typename?: 'Deployment';
            id: string;
            displayLocation: string;
          } | null;
        }
      | null;
    tasks: Array<
      {
        __typename?: 'Task';
        id: string;
        status: JobStatus;
        required?: boolean | null;
        name: string;
        type: string;
        description: string;
        notes?: string | null;
      } & { ' $fragmentRefs'?: { TaskDataFragment: TaskDataFragment } }
    >;
    owner: {
      __typename?: 'Organisation';
      id: string;
      name: string;
      logo?: string | null;
    };
    booking?: {
      __typename?: 'Booking';
      id: string;
      name?: string | null;
      start: any;
      end: any;
    } | null;
    occupied?: {
      __typename?: 'Booking';
      id: string;
      checkIn: any;
      checkOut: any;
    } | null;
    prevCheckOut?: {
      __typename?: 'Booking';
      id: string;
      checkIn: any;
      checkOut: any;
    } | null;
    nextCheckIn?: {
      __typename?: 'Booking';
      id: string;
      checkIn: any;
      checkOut: any;
    } | null;
    site?: { __typename?: 'Site'; id: string; image?: string | null } | null;
  } | null;
};

export type TaskDataFragment = ({
  __typename?: 'Task';
  id: string;
  status: JobStatus;
  type: string;
  name: string;
  description: string;
  required?: boolean | null;
  jobAttributeIds?: Array<string> | null;
  notes?: string | null;
  tags: {
    __typename?: 'TagConnection';
    nodes: Array<{
      __typename?: 'Tag';
      id: string;
      entityType: string;
      category?: string | null;
      name: string;
      description?: string | null;
      colour: string;
    }>;
  };
  attributes?: Array<{
    __typename?: 'Attribute';
    id: string;
    type: string;
    category?: string | null;
    name: string;
    value: Array<string>;
  }> | null;
  assets: Array<{
    __typename?: 'Asset';
    id: string;
    status: Status;
    type: string;
    name: string;
    image?: string | null;
    attributes?: Array<{
      __typename?: 'Attribute';
      name: string;
      value: Array<string>;
    }> | null;
    model?: {
      __typename?: 'AssetModel';
      id: string;
      brand: string;
      name: string;
    } | null;
    deployment?: {
      __typename?: 'Deployment';
      id: string;
      displayLocation: string;
      startedAt: any;
      image?: string | null;
      location:
        | { __typename: 'Asset'; id: string; name: string }
        | { __typename: 'Contact'; id: string; name: string }
        | { __typename: 'Elsewhere'; id: string; name: string }
        | { __typename: 'Fsp'; id: string; name: string }
        | { __typename: 'Site'; id: string; name: string }
        | { __typename: 'StockTransfer'; id: string; name: string };
      space: { __typename?: 'Space'; id: string; name: string };
    } | null;
  }>;
  config?: {
    __typename?: 'AssetTaskConfig';
    selection: string;
    spaces: Array<string>;
    assetTypes: Array<string>;
    allow: Array<string>;
    shareAttributes: boolean;
    shareJobHistory: boolean;
    shareDeploymentHistory: boolean;
  } | null;
  purchase?: {
    __typename?: 'PurchaseTask';
    id: string;
    spaces: Array<string>;
    movements?: Array<{
      __typename?: 'PurchaseTaskItem';
      id: string;
      qty: number;
    }> | null;
  } | null;
  stocktake?: {
    __typename?: 'Stocktake';
    id: string;
    include: Array<ItemType>;
    itemStatus: Array<Status>;
    spaces: Array<string>;
  } | null;
  stockTransfer?: {
    __typename?: 'StockTransfer';
    id: string;
    status: StockTransferStatus;
    sourceString: string;
    destinationString: string;
  } | null;
} & { ' $fragmentRefs'?: { AttributeTaskFragment: AttributeTaskFragment } }) & {
  ' $fragmentName'?: 'TaskDataFragment';
};

export type AttributeTaskFragment = {
  __typename?: 'Task';
  id: string;
  name: string;
  description: string;
  status: JobStatus;
  required?: boolean | null;
  attributes?: Array<{
    __typename?: 'Attribute';
    id: string;
    type: string;
    category?: string | null;
    name: string;
    value: Array<string>;
  }> | null;
  attribute?: {
    __typename?: 'AttributeTask';
    id: string;
    attributes: Array<string>;
    formValues?: Array<{
      __typename?: 'Attribute';
      name: string;
      value: Array<string>;
    }> | null;
  } | null;
} & { ' $fragmentName'?: 'AttributeTaskFragment' };

export type SiteAttributesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SiteAttributesQuery = {
  __typename?: 'Query';
  site: {
    __typename?: 'Site';
    id: string;
    attributes?: Array<
      { __typename?: 'Attribute'; id: string; value: Array<string> } & {
        ' $fragmentRefs'?: {
          Attribute_AttributeFragmentFragment: Attribute_AttributeFragmentFragment;
        };
      }
    > | null;
  };
};

export type AddTagsToTaggableMutationVariables = Exact<{
  input: AddTagsToTaggableInput;
}>;

export type AddTagsToTaggableMutation = {
  __typename?: 'Mutation';
  addTagsToTaggable: {
    __typename: 'Task';
    id: string;
    tags: {
      __typename?: 'TagConnection';
      nodes: Array<{
        __typename?: 'Tag';
        id: string;
        entityType: string;
        name: string;
        category?: string | null;
        description?: string | null;
        colour: string;
      }>;
    };
  };
};

export type RemoveTagsFromTaggableMutationVariables = Exact<{
  input: RemoveTagsFromTaggableInput;
}>;

export type RemoveTagsFromTaggableMutation = {
  __typename?: 'Mutation';
  removeTagsFromTaggable: {
    __typename: 'Task';
    id: string;
    tags: {
      __typename?: 'TagConnection';
      nodes: Array<{
        __typename?: 'Tag';
        id: string;
        entityType: string;
        name: string;
        category?: string | null;
        description?: string | null;
        colour: string;
      }>;
    };
  };
};

export type CompleteCustomTaskMutationVariables = Exact<{
  input: CompleteTaskInput;
}>;

export type CompleteCustomTaskMutation = {
  __typename?: 'Mutation';
  completeCustomTask: {
    __typename?: 'Task';
    id: string;
    status: JobStatus;
    updatedAt: any;
    job: { __typename?: 'Job'; id: string; status: JobStatus };
  };
};

export type AdvanceTenantOnboardingStepMutationVariables = Exact<{
  flowKey: Scalars['String']['input'];
  totalSteps: Scalars['Int']['input'];
}>;

export type AdvanceTenantOnboardingStepMutation = {
  __typename?: 'Mutation';
  advanceTenantOnboardingStep?: {
    __typename: 'OnboardingFlow';
    flowKey: string;
    currentStep?: number | null;
    completedAt?: string | null;
    completedByUserId?: string | null;
  } | null;
};

export type OnboardingListJobTemplatesQueryVariables = Exact<{
  status?: InputMaybe<Status>;
}>;

export type OnboardingListJobTemplatesQuery = {
  __typename?: 'Query';
  jobTemplates: Array<{
    __typename?: 'JobTemplate';
    id: string;
    name: string;
    isStarter: boolean;
    status: Status;
    tasks: Array<{
      __typename?: 'Task';
      id: string;
      type: string;
      name: string;
      description: string;
      jobAttributeIds?: Array<string> | null;
      attributes?: Array<{
        __typename?: 'Attribute';
        id: string;
        type: string;
        category?: string | null;
        name: string;
        value: Array<string>;
      }> | null;
      tags: {
        __typename?: 'TagConnection';
        nodes: Array<{
          __typename?: 'Tag';
          id: string;
          entityType: string;
          name: string;
          category?: string | null;
          description?: string | null;
          colour: string;
        }>;
      };
      config?: {
        __typename?: 'AssetTaskConfig';
        selection: string;
        spaces: Array<string>;
        assetTypes: Array<string>;
        allow: Array<string>;
        shareAttributes: boolean;
        shareJobHistory: boolean;
        shareDeploymentHistory: boolean;
      } | null;
      assets: Array<{
        __typename?: 'Asset';
        id: string;
        name: string;
        type: string;
      }>;
      attribute?: {
        __typename?: 'AttributeTask';
        id: string;
        attributes: Array<string>;
      } | null;
    }>;
  }>;
};

export type SpacesByLocationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SpacesByLocationQuery = {
  __typename?: 'Query';
  location:
    | {
        __typename?: 'Asset';
        id: string;
        spaces: Array<{
          __typename?: 'Space';
          id: string;
          name: string;
          image?: string | null;
        }>;
      }
    | {
        __typename?: 'Contact';
        id: string;
        spaces: Array<{
          __typename?: 'Space';
          id: string;
          name: string;
          image?: string | null;
        }>;
      }
    | {
        __typename?: 'Elsewhere';
        id: string;
        spaces: Array<{
          __typename?: 'Space';
          id: string;
          name: string;
          image?: string | null;
        }>;
      }
    | {
        __typename?: 'Fsp';
        id: string;
        spaces: Array<{
          __typename?: 'Space';
          id: string;
          name: string;
          image?: string | null;
        }>;
      }
    | {
        __typename?: 'Site';
        id: string;
        spaces: Array<{
          __typename?: 'Space';
          id: string;
          name: string;
          image?: string | null;
        }>;
      }
    | {
        __typename?: 'StockTransfer';
        id: string;
        spaces: Array<{
          __typename?: 'Space';
          id: string;
          name: string;
          image?: string | null;
        }>;
      };
};

export type AttributeFieldsFragment = {
  __typename?: 'Attribute';
  id: string;
  type: string;
  category?: string | null;
  name: string;
  value: Array<string>;
  attachments?: Array<{
    __typename?: 'Attachment';
    id: string;
    kind: string;
    ext: string;
    thumb: string;
    url: string;
    originalFilename: string;
  }> | null;
} & { ' $fragmentName'?: 'AttributeFieldsFragment' };

export type SiteJobs_JobFragment = {
  __typename?: 'Job';
  id: string;
  status: JobStatus;
  name: string;
  scheduleStart?: any | null;
  scheduleEnd?: any | null;
  scheduledStartStrict: boolean;
  scheduledStartDate?: any | null;
  scheduledStartTime?: any | null;
  scheduledEndStrict: boolean;
  scheduledEndDate?: any | null;
  scheduledEndTime?: any | null;
  completedAt?: any | null;
  timeZone: string;
  location?:
    | { __typename?: 'Asset'; id: string; name: string }
    | { __typename?: 'Contact'; id: string; name: string }
    | { __typename?: 'Elsewhere'; id: string; name: string }
    | { __typename?: 'Fsp'; id: string; name: string }
    | { __typename?: 'Site'; id: string; name: string }
    | { __typename?: 'StockTransfer'; id: string; name: string }
    | null;
  assignee?: {
    __typename?: 'Contact';
    id: string;
    name: string;
    image?: string | null;
  } | null;
} & { ' $fragmentName'?: 'SiteJobs_JobFragment' };

export type SiteJobsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  scheduled: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SiteJobsQuery = {
  __typename?: 'Query';
  site: {
    __typename?: 'Site';
    id: string;
    jobs: {
      __typename?: 'JobsConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'JobsEdge';
        cursor: string;
        node: { __typename?: 'Job' } & {
          ' $fragmentRefs'?: { SiteJobs_JobFragment: SiteJobs_JobFragment };
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        endCursor?: string | null;
      };
    };
  };
};

export type CompletePurchaseTaskMutationVariables = Exact<{
  input: CompletePurchaseTaskInput;
}>;

export type CompletePurchaseTaskMutation = {
  __typename?: 'Mutation';
  completePurchaseTask: number;
};

export type AttachmentFieldsFragment = {
  __typename?: 'Attachment';
  id: string;
  kind: string;
  ext: string;
  thumb: string;
  url: string;
  originalFilename: string;
} & { ' $fragmentName'?: 'AttachmentFieldsFragment' };

export type ListIntegrationsQueryVariables = Exact<{ [key: string]: never }>;

export type ListIntegrationsQuery = {
  __typename?: 'Query';
  integrations: Array<string>;
};

export type AssetTypeConfigQueryVariables = Exact<{ [key: string]: never }>;

export type AssetTypeConfigQuery = {
  __typename?: 'Query';
  assetTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
    updatedAt: any;
  };
};

export type UpdateAssetTypeConfigMutationVariables = Exact<{
  input: UpdatePlaceTypeConfigInput;
}>;

export type UpdateAssetTypeConfigMutation = {
  __typename?: 'Mutation';
  updateAssetTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
    updatedAt: any;
  };
};

export type AssetTypeCounts_LiveCheckQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AssetTypeCounts_LiveCheckQuery = {
  __typename?: 'Query';
  hasUntypedAssets: boolean;
  assetTypeCounts: Array<{
    __typename?: 'SiteTypeCount';
    type?: string | null;
    count: number;
  }>;
};

export type AllAssetsFreshQueryVariables = Exact<{ [key: string]: never }>;

export type AllAssetsFreshQuery = {
  __typename?: 'Query';
  assets: Array<{
    __typename?: 'Asset';
    id: string;
    status: Status;
    type: string;
    name: string;
  }>;
};

export type AssetTypeConfig_NavQueryVariables = Exact<{ [key: string]: never }>;

export type AssetTypeConfig_NavQuery = {
  __typename?: 'Query';
  assetTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
  };
};

export type AssetTypeCounts_NavQueryVariables = Exact<{ [key: string]: never }>;

export type AssetTypeCounts_NavQuery = {
  __typename?: 'Query';
  hasUntypedAssets: boolean;
  assetTypeCounts: Array<{
    __typename?: 'SiteTypeCount';
    type?: string | null;
    count: number;
  }>;
};

export type AllAssetsFresh_SingleQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllAssetsFresh_SingleQuery = {
  __typename?: 'Query';
  assets: Array<{
    __typename?: 'Asset';
    id: string;
    status: Status;
    type: string;
    name: string;
  }>;
};

export type AllAssetsFresh_Rename2QueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllAssetsFresh_Rename2Query = {
  __typename?: 'Query';
  assets: Array<{
    __typename?: 'Asset';
    id: string;
    status: Status;
    type: string;
    name: string;
  }>;
};

export type AllAssetsFresh_BulkQueryVariables = Exact<{ [key: string]: never }>;

export type AllAssetsFresh_BulkQuery = {
  __typename?: 'Query';
  assets: Array<{
    __typename?: 'Asset';
    id: string;
    status: Status;
    type: string;
    name: string;
  }>;
};

export type ContactTypeConfig_RelationshipsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactTypeConfig_RelationshipsQuery = {
  __typename?: 'Query';
  contactTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
    updatedAt: any;
  };
};

export type ContactsByRelationshipQueryVariables = Exact<{
  relationship?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type ContactsByRelationshipQuery = {
  __typename?: 'Query';
  contacts: Array<{
    __typename?: 'Contact';
    id: string;
    name: string;
    status: Status;
    type: ContactType;
    relationship: Array<string>;
  }>;
};

export type ContactsRelless_LiveCheckQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactsRelless_LiveCheckQuery = {
  __typename?: 'Query';
  hasUntypedContacts: boolean;
  contactTypesInUse: Array<string>;
};

export type ContactsQueryVariables = Exact<{
  status?: InputMaybe<Array<Status> | Status>;
  relationship?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type ContactsQuery = {
  __typename?: 'Query';
  contacts: Array<{
    __typename?: 'Contact';
    id: string;
    status: Status;
    type: ContactType;
    name: string;
    email?: string | null;
    phone?: string | null;
    relationship: Array<string>;
    image?: string | null;
    isCurrentUser: boolean;
    isTeamMember: boolean;
  }>;
};

export type ContactTypeMappingsForListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactTypeMappingsForListQuery = {
  __typename?: 'Query';
  contactTypeMappings: Array<{
    __typename?: 'ContactTypeMapping';
    label: string;
    relationships: Array<string>;
  }>;
};

export type UpdateContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ContactInput;
}>;

export type UpdateContactMutation = {
  __typename?: 'Mutation';
  updateContact?: {
    __typename: 'Contact';
    id: string;
    name: string;
    status: Status;
    type: ContactType;
    relationship: Array<string>;
  } | null;
};

export type ContactTypesPresetQueryVariables = Exact<{
  preset?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ContactTypesPresetQuery = {
  __typename?: 'Query';
  contactTypes: Array<string>;
};

export type ContactTypesInUseQueryVariables = Exact<{ [key: string]: never }>;

export type ContactTypesInUseQuery = {
  __typename?: 'Query';
  contactTypesInUse: Array<string>;
};

export type AllContactsForTypesQueryVariables = Exact<{ [key: string]: never }>;

export type AllContactsForTypesQuery = {
  __typename?: 'Query';
  contacts: Array<{
    __typename?: 'Contact';
    id: string;
    relationship: Array<string>;
  }>;
};

export type UpdateContactTypeConfig_RelationshipsMutationVariables = Exact<{
  input: UpdatePlaceTypeConfigInput;
}>;

export type UpdateContactTypeConfig_RelationshipsMutation = {
  __typename?: 'Mutation';
  updateContactTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
    updatedAt: any;
  };
};

export type AllContactsFresh_BulkQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllContactsFresh_BulkQuery = {
  __typename?: 'Query';
  contacts: Array<{
    __typename?: 'Contact';
    id: string;
    name: string;
    status: Status;
    type: ContactType;
    relationship: Array<string>;
  }>;
};

export type ContactsRelless_NavQueryVariables = Exact<{ [key: string]: never }>;

export type ContactsRelless_NavQuery = {
  __typename?: 'Query';
  hasUntypedContacts: boolean;
  contactTypesInUse: Array<string>;
};

export type AllContactsFreshQueryVariables = Exact<{ [key: string]: never }>;

export type AllContactsFreshQuery = {
  __typename?: 'Query';
  contacts: Array<{
    __typename?: 'Contact';
    id: string;
    name: string;
    status: Status;
    type: ContactType;
    relationship: Array<string>;
  }>;
};

export type AllContactsFresh_SingleQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllContactsFresh_SingleQuery = {
  __typename?: 'Query';
  contacts: Array<{
    __typename?: 'Contact';
    id: string;
    name: string;
    status: Status;
    type: ContactType;
    relationship: Array<string>;
  }>;
};

export type AllSitesFreshQueryVariables = Exact<{ [key: string]: never }>;

export type AllSitesFreshQuery = {
  __typename?: 'Query';
  sites: Array<{
    __typename?: 'Site';
    id: string;
    type?: string | null;
    status: Status;
    name: string;
    address?: string | null;
    images: Array<string>;
    notes?: string | null;
    airbnbDefaultCheckIn?: string | null;
    airbnbDefaultCheckOut?: string | null;
    licensor?: { __typename?: 'Organisation'; id: string } | null;
    defaultSource?: { __typename?: 'Site'; id: string } | null;
    homhero?: { __typename?: 'HomheroArea'; id: string } | null;
    airbnbCalendar?: Array<{
      __typename?: 'CalendarSubscription';
      url: string;
    }> | null;
    attributes?: Array<{
      __typename?: 'Attribute';
      id: string;
      name: string;
      value: Array<string>;
    }> | null;
  }>;
};

export type SiteTypeCounts_RefreshQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SiteTypeCounts_RefreshQuery = {
  __typename?: 'Query';
  siteTypeCounts: Array<{
    __typename?: 'SiteTypeCount';
    type?: string | null;
    count: number;
  }>;
};

export type PlaceTypeConfig_RefreshQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PlaceTypeConfig_RefreshQuery = {
  __typename?: 'Query';
  placeTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
  };
};

export type UpdatePlaceTypeConfigMutationVariables = Exact<{
  input: UpdatePlaceTypeConfigInput;
}>;

export type UpdatePlaceTypeConfigMutation = {
  __typename?: 'Mutation';
  updatePlaceTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
    updatedAt: any;
  };
};

export type RenamePlaceTypeMutationVariables = Exact<{
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;

export type RenamePlaceTypeMutation = {
  __typename?: 'Mutation';
  renamePlaceType: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
    updatedAt: any;
  };
};

export type SiteTypeCounts_LiveCheckQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SiteTypeCounts_LiveCheckQuery = {
  __typename?: 'Query';
  siteTypeCounts: Array<{
    __typename?: 'SiteTypeCount';
    type?: string | null;
    count: number;
  }>;
};

export type PlaceTypeConfig_Nav_ForceQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PlaceTypeConfig_Nav_ForceQuery = {
  __typename?: 'Query';
  placeTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
    isCustomized: boolean;
  };
};

export type SiteTypeCounts_ForceRefresh_MultiQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SiteTypeCounts_ForceRefresh_MultiQuery = {
  __typename?: 'Query';
  siteTypeCounts: Array<{
    __typename?: 'SiteTypeCount';
    type?: string | null;
    count: number;
  }>;
};

export type SiteTypeCounts_ForceRefresh_PlaceSingleQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SiteTypeCounts_ForceRefresh_PlaceSingleQuery = {
  __typename?: 'Query';
  siteTypeCounts: Array<{
    __typename?: 'SiteTypeCount';
    type?: string | null;
    count: number;
  }>;
};

export type SiteTypeCounts_ForceRefresh2_PlaceBgQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SiteTypeCounts_ForceRefresh2_PlaceBgQuery = {
  __typename?: 'Query';
  siteTypeCounts: Array<{
    __typename?: 'SiteTypeCount';
    type?: string | null;
    count: number;
  }>;
};

export type UpdateAssetSharingDefaultsMutationVariables = Exact<{
  input: AssetSharingDefaultsInput;
}>;

export type UpdateAssetSharingDefaultsMutation = {
  __typename?: 'Mutation';
  updateAssetSharingDefaults: {
    __typename?: 'AssetSharingDefaults';
    shareAttributes: boolean;
    shareJobHistory: boolean;
    shareDeploymentHistory: boolean;
  };
};

export type ContactFieldsFragment = {
  __typename?: 'Contact';
  id: string;
  status: Status;
  type: ContactType;
  name: string;
  email?: string | null;
  phone?: string | null;
  relationship: Array<string>;
  image?: string | null;
  isCurrentUser: boolean;
  isTeamMember: boolean;
} & { ' $fragmentName'?: 'ContactFieldsFragment' };

export type JobTemplateFieldsFragment = {
  __typename?: 'JobTemplate';
  id: string;
  isStarter: boolean;
  status: Status;
  name: string;
  behavior: TemplateBehavior;
  quickCreate: boolean;
  notes?: string | null;
  includeAttributes?: Array<string> | null;
  jobAttributeIds?: Array<string> | null;
  guestyCleaningStatus?: string | null;
  tags?: Array<{
    __typename?: 'Tag';
    id: string;
    entityType: string;
    category?: string | null;
    name: string;
    description?: string | null;
    colour: string;
  }> | null;
  attachments?: Array<{
    __typename?: 'Attachment';
    id: string;
    kind: string;
    ext: string;
    thumb: string;
    url: string;
    originalFilename: string;
  }> | null;
  tasks: Array<{
    __typename?: 'Task';
    id: string;
    type: string;
    name: string;
    description: string;
    jobAttributeIds?: Array<string> | null;
    tags: {
      __typename?: 'TagConnection';
      nodes: Array<{
        __typename?: 'Tag';
        id: string;
        entityType: string;
        name: string;
        category?: string | null;
        description?: string | null;
        colour: string;
      }>;
    };
    attributes?: Array<{
      __typename?: 'Attribute';
      id: string;
      type: string;
      category?: string | null;
      name: string;
      value: Array<string>;
    }> | null;
    attribute?: {
      __typename?: 'AttributeTask';
      id: string;
      attributes: Array<string>;
    } | null;
    purchase?: {
      __typename?: 'PurchaseTask';
      id: string;
      spaces: Array<string>;
    } | null;
    stocktake?:
      | ({ __typename?: 'Stocktake' } & {
          ' $fragmentRefs'?: {
            StocktakeTaskFieldsFragment: StocktakeTaskFieldsFragment;
          };
        })
      | null;
    config?: {
      __typename?: 'AssetTaskConfig';
      selection: string;
      spaces: Array<string>;
      assetTypes: Array<string>;
      allow: Array<string>;
      shareAttributes: boolean;
      shareJobHistory: boolean;
      shareDeploymentHistory: boolean;
    } | null;
    assets: Array<{
      __typename?: 'Asset';
      id: string;
      name: string;
      type: string;
    }>;
  }>;
} & { ' $fragmentName'?: 'JobTemplateFieldsFragment' };

export type StocktakeTaskFieldsFragment = {
  __typename?: 'Stocktake';
  id: string;
  include: Array<ItemType>;
  itemStatus: Array<Status>;
  spaces: Array<string>;
  items: Array<{
    __typename?: 'StocktakeItem';
    id: string;
    adjustment: number;
    newOnHand: number;
  }>;
} & { ' $fragmentName'?: 'StocktakeTaskFieldsFragment' };

export type UpdateJobTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: JobTemplateInput;
}>;

export type UpdateJobTemplateMutation = {
  __typename?: 'Mutation';
  updateJobTemplate: { __typename?: 'JobTemplate'; id: string } & {
    ' $fragmentRefs'?: { JobTemplateFieldsFragment: JobTemplateFieldsFragment };
  };
};

export type ScheduleQueryVariables = Exact<{
  names?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type ScheduleQuery = {
  __typename?: 'Query';
  tags: {
    __typename?: 'TagConnection';
    nodes: Array<{
      __typename?: 'Tag';
      id: string;
      entityType: string;
      category?: string | null;
      name: string;
      description?: string | null;
      colour: string;
    }>;
  };
  assignees: Array<{ __typename?: 'Contact'; id: string; name: string }>;
  sites: Array<{
    __typename?: 'Site';
    id: string;
    name: string;
    address?: string | null;
    image?: string | null;
    calendarBounds: Array<any>;
    attributes?: Array<{
      __typename: 'Attribute';
      id: string;
      type: string;
      category?: string | null;
      name: string;
      value: Array<string>;
    }> | null;
    calendar: Array<{
      __typename?: 'ScheduleEvent';
      id: string;
      summary: string;
      status: string;
      start: any;
      end?: any | null;
      scheduledStartTime?: any | null;
      scheduledEndTime?: any | null;
      timeZone: string;
      tags?: Array<string> | null;
      assignee?: {
        __typename?: 'Contact';
        id: string;
        name: string;
        image?: string | null;
      } | null;
      included?: Array<{
        __typename?: 'Contact';
        id: string;
        name: string;
        image?: string | null;
      }> | null;
      attributes?: Array<{
        __typename?: 'Attribute';
        id: string;
        type: string;
        category?: string | null;
        name: string;
        value: Array<string>;
      }> | null;
    }>;
  }>;
};

export type TaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type TaskQuery = {
  __typename?: 'Query';
  task: {
    __typename?: 'Task';
    id: string;
    required?: boolean | null;
    type: string;
    status: JobStatus;
    name: string;
    description: string;
    jobAttributeIds?: Array<string> | null;
    notes?: string | null;
    tags: {
      __typename?: 'TagConnection';
      nodes: Array<{
        __typename?: 'Tag';
        id: string;
        entityType: string;
        name: string;
        category?: string | null;
        description?: string | null;
        colour: string;
      }>;
    };
    attributes?: Array<{
      __typename?: 'Attribute';
      id: string;
      type: string;
      category?: string | null;
      name: string;
      value: Array<string>;
      attachments?: Array<{
        __typename?: 'Attachment';
        id: string;
        kind: string;
        ext: string;
        thumb: string;
        url: string;
        originalFilename: string;
      }> | null;
    }> | null;
    taskAttributes?: Array<{
      __typename?: 'AttributeV2';
      id: string;
      value?: string | null;
    }> | null;
    attachments?: Array<
      { __typename?: 'Attachment' } & {
        ' $fragmentRefs'?: {
          AttachmentFieldsFragment: AttachmentFieldsFragment;
        };
      }
    > | null;
    job: { __typename?: 'Job'; id: string };
    config?: {
      __typename?: 'AssetTaskConfig';
      selection: string;
      spaces: Array<string>;
      assetTypes: Array<string>;
      allow: Array<string>;
      shareAttributes: boolean;
      shareJobHistory: boolean;
      shareDeploymentHistory: boolean;
    } | null;
    assets: Array<{
      __typename?: 'Asset';
      id: string;
      name: string;
      image?: string | null;
      type: string;
      model?: {
        __typename?: 'AssetModel';
        id: string;
        displayName: string;
      } | null;
      deployment?: {
        __typename?: 'Deployment';
        id: string;
        image?: string | null;
        location:
          | { __typename?: 'Asset'; id: string; name: string }
          | { __typename?: 'Contact'; id: string; name: string }
          | { __typename?: 'Elsewhere'; id: string; name: string }
          | { __typename?: 'Fsp'; id: string; name: string }
          | { __typename?: 'Site'; id: string; name: string }
          | { __typename?: 'StockTransfer'; id: string; name: string };
        space: { __typename?: 'Space'; id: string; name: string };
      } | null;
    }>;
    purchase?: {
      __typename?: 'PurchaseTask';
      id: string;
      spaces: Array<string>;
      movements?: Array<{
        __typename?: 'PurchaseTaskItem';
        id: string;
        qty: number;
      }> | null;
    } | null;
    stocktake?: {
      __typename?: 'Stocktake';
      id: string;
      include: Array<ItemType>;
      itemStatus: Array<Status>;
      spaces: Array<string>;
      items: Array<{
        __typename?: 'StocktakeItem';
        id: string;
        adjustment: number;
        newOnHand: number;
      }>;
    } | null;
    stockTransfer?: {
      __typename?: 'StockTransfer';
      id: string;
      rule: StockTransferRule;
      items: Array<{
        __typename?: 'StockTransferItem';
        id: string;
        spaceId: string;
        skuId: string;
        pick: number;
        picked?: number | null;
        packed?: number | null;
        dispatched?: number | null;
        received?: number | null;
        putAway?: number | null;
      }>;
    } | null;
    transfer?: {
      __typename?: 'TransferTask';
      available: Array<{ __typename?: 'ItemQty'; id: string; qty: number }>;
      moved: Array<{ __typename?: 'ItemQty'; id: string; qty: number }>;
      stockOnHand: Array<{
        __typename?: 'SpaceSku';
        id: string;
        reserved: number;
        soh: number;
        target?: number | null;
        capacity?: number | null;
        reorderLevel?: number | null;
        space: {
          __typename?: 'Space';
          id: string;
          name: string;
          location:
            | { __typename: 'Asset'; id: string; name: string }
            | { __typename: 'Contact'; id: string; name: string }
            | { __typename: 'Elsewhere'; id: string; name: string }
            | { __typename: 'Fsp'; id: string; name: string }
            | { __typename: 'Site'; id: string; name: string }
            | { __typename: 'StockTransfer'; id: string; name: string };
          attributes?: Array<{
            __typename?: 'Attribute';
            name: string;
            value: Array<string>;
          }> | null;
        };
        sku: {
          __typename?: 'Sku';
          id: string;
          code?: string | null;
          name: string;
          itemType: ItemType;
          image?: string | null;
          attributes: Array<{
            __typename?: 'AttributeSingle';
            name: string;
            value: string;
          }>;
        };
      }>;
    } | null;
  } & { ' $fragmentRefs'?: { AttributeTaskFragment: AttributeTaskFragment } };
};

export type ListJobTemplatesQueryVariables = Exact<{
  status?: InputMaybe<Status>;
}>;

export type ListJobTemplatesQuery = {
  __typename?: 'Query';
  jobTemplates: Array<
    { __typename?: 'JobTemplate'; id: string; name: string } & {
      ' $fragmentRefs'?: {
        JobTemplateFieldsFragment: JobTemplateFieldsFragment;
      };
    }
  >;
};

export type ContactNavConfig_NavQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ContactNavConfig_NavQuery = {
  __typename?: 'Query';
  contactTypeConfig: {
    __typename?: 'PlaceTypeConfig';
    types: Array<string>;
    orderMode: PlaceTypeOrderMode;
    navTypes: Array<string>;
    showAllInNav: boolean;
  };
};

export type ContactTypesPreset_NavQueryVariables = Exact<{
  preset?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ContactTypesPreset_NavQuery = {
  __typename?: 'Query';
  contactTypes: Array<string>;
};

export type ActivityNav_TotalCountQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  showMessages?: InputMaybe<Scalars['Boolean']['input']>;
  showStatus?: InputMaybe<Scalars['Boolean']['input']>;
  showTaskNotes?: InputMaybe<Scalars['Boolean']['input']>;
  unread?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  author?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  dateRange?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type ActivityNav_TotalCountQuery = {
  __typename?: 'Query';
  allActivity: { __typename?: 'ActivityConnection'; totalCount: number };
};

export type AddTagsToActivityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AddTagsToActivityMutation = {
  __typename?: 'Mutation';
  addTagsToActivity: {
    __typename?: 'Activity';
    id: string;
    tags?: Array<{
      __typename?: 'Tag';
      id: string;
      entityType: string;
      category?: string | null;
      name: string;
      description?: string | null;
      colour: string;
    }> | null;
  };
};

export type RemoveTagsFromActivityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RemoveTagsFromActivityMutation = {
  __typename?: 'Mutation';
  removeTagsFromActivity: {
    __typename?: 'Activity';
    id: string;
    tags?: Array<{
      __typename?: 'Tag';
      id: string;
      entityType: string;
      category?: string | null;
      name: string;
      description?: string | null;
      colour: string;
    }> | null;
  };
};

export type ActivityQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  showMessages?: InputMaybe<Scalars['Boolean']['input']>;
  showStatus?: InputMaybe<Scalars['Boolean']['input']>;
  showTaskNotes?: InputMaybe<Scalars['Boolean']['input']>;
  unread?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  author?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  dateRange?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  commentTagIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  jobTagIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  taskTagIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  query?: InputMaybe<Scalars['String']['input']>;
  excludeAutomation?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ActivityQuery = {
  __typename?: 'Query';
  tags: {
    __typename?: 'TagConnection';
    nodes: Array<{
      __typename?: 'Tag';
      id: string;
      entityType: string;
      category?: string | null;
      name: string;
      description?: string | null;
      colour: string;
    }>;
  };
  allActivity: {
    __typename?: 'ActivityConnection';
    totalCount: number;
    totalUnreadCount: number;
    edges: Array<{
      __typename?: 'ActivityEdge';
      cursor: string;
      node: { __typename?: 'Activity'; id: string; createdAt: any } & {
        ' $fragmentRefs'?: {
          ActivityListItem_ActivityFragmentFragment: ActivityListItem_ActivityFragmentFragment;
        };
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
  };
};

export type Activities_TotalCountQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  showMessages?: InputMaybe<Scalars['Boolean']['input']>;
  showStatus?: InputMaybe<Scalars['Boolean']['input']>;
  showTaskNotes?: InputMaybe<Scalars['Boolean']['input']>;
  unread?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  author?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  dateRange?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  commentTagIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  jobTagIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  taskTagIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  query?: InputMaybe<Scalars['String']['input']>;
  excludeAutomation?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type Activities_TotalCountQuery = {
  __typename?: 'Query';
  allActivity: { __typename?: 'ActivityConnection'; totalCount: number };
};

export type ActivityUnreadCountQueryVariables = Exact<{ [key: string]: never }>;

export type ActivityUnreadCountQuery = {
  __typename?: 'Query';
  allActivity: { __typename?: 'ActivityConnection'; totalUnreadCount: number };
};

export type AssetJobsRouteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AssetJobsRouteQuery = {
  __typename?: 'Query';
  asset?: {
    __typename?: 'Asset';
    id: string;
    jobs: Array<{
      __typename?: 'Job';
      id: string;
      status: JobStatus;
      name: string;
      _dateScheduled?: string | null;
      scheduleStart?: any | null;
      scheduleEnd?: any | null;
      scheduledStartStrict: boolean;
      scheduledStartDate?: any | null;
      scheduledStartTime?: any | null;
      scheduledEndStrict: boolean;
      scheduledEndDate?: any | null;
      scheduledEndTime?: any | null;
      timeZone: string;
      location?:
        | { __typename: 'Asset'; id: string; name: string }
        | { __typename: 'Contact'; id: string; name: string }
        | { __typename: 'Elsewhere'; id: string; name: string }
        | { __typename: 'Fsp'; id: string; name: string }
        | { __typename: 'Site'; id: string; name: string }
        | { __typename: 'StockTransfer'; id: string; name: string }
        | null;
      assignee?: { __typename?: 'Contact'; id: string; name: string } | null;
    }>;
  } | null;
};

export type CreateJobFormQueryVariables = Exact<{ [key: string]: never }>;

export type CreateJobFormQuery = {
  __typename?: 'Query';
  integrations: Array<string>;
  jobNameOptions: Array<string>;
  attributes: Array<{
    __typename?: 'Attribute';
    id: string;
    type: string;
    category?: string | null;
    name: string;
    value: Array<string>;
    condition?: string | null;
  }>;
  jobTemplates: Array<
    { __typename?: 'JobTemplate' } & {
      ' $fragmentRefs'?: {
        JobTemplateFieldsFragment: JobTemplateFieldsFragment;
      };
    }
  >;
  locations: Array<
    | {
        __typename: 'Asset';
        id: string;
        name: string;
        deployment?: {
          __typename?: 'Deployment';
          id: string;
          displayLocation: string;
          defaultSourceId?: string | null;
        } | null;
      }
    | { __typename: 'Contact'; id: string; name: string }
    | { __typename: 'Elsewhere'; id: string; name: string }
    | { __typename: 'Fsp'; id: string; name: string }
    | { __typename: 'Site'; id: string; name: string }
    | { __typename: 'StockTransfer'; id: string; name: string }
  >;
  contacts: Array<
    { __typename?: 'Contact' } & {
      ' $fragmentRefs'?: { ContactFieldsFragment: ContactFieldsFragment };
    }
  >;
};

export type UpdateAutomationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AutomationInput;
}>;

export type UpdateAutomationMutation = {
  __typename?: 'Mutation';
  updateAutomation?: string | null;
};

export type GetAllJobTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllJobTemplatesQuery = {
  __typename?: 'Query';
  jobTemplates: Array<
    { __typename?: 'JobTemplate' } & {
      ' $fragmentRefs'?: {
        JobTemplateFieldsFragment: JobTemplateFieldsFragment;
      };
    }
  >;
};

export type ListAutomationsQueryVariables = Exact<{ [key: string]: never }>;

export type ListAutomationsQuery = {
  __typename?: 'Query';
  automations: Array<{
    __typename?: 'Automation';
    id: string;
    status: Status;
    name: string;
    on: string;
    whereType: AutomationWhereType;
    do: string;
    jobName: string;
    day: number;
    time?: string | null;
    repeatUntilOffset?: number | null;
    repeatStartDate?: any | null;
    maintainRepeats?: number | null;
    matchAttribute?: Array<{
      __typename?: 'Attribute';
      value: Array<string>;
      key: string;
    }> | null;
    sites: Array<{
      __typename?: 'Site';
      id: string;
      name: string;
      image?: string | null;
    }>;
    template: {
      __typename?: 'JobTemplate';
      id: string;
      status: Status;
      name: string;
      notes?: string | null;
      includeAttributes?: Array<string> | null;
      jobAttributeIds?: Array<string> | null;
      guestyCleaningStatus?: string | null;
      tags?: Array<{
        __typename?: 'Tag';
        id: string;
        entityType: string;
        category?: string | null;
        name: string;
        description?: string | null;
        colour: string;
      }> | null;
      attachments?: Array<{
        __typename?: 'Attachment';
        id: string;
        kind: string;
        ext: string;
        thumb: string;
        url: string;
        originalFilename: string;
      }> | null;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        type: string;
        name: string;
        description: string;
        jobAttributeIds?: Array<string> | null;
        tags: {
          __typename?: 'TagConnection';
          nodes: Array<{
            __typename?: 'Tag';
            id: string;
            entityType: string;
            name: string;
            category?: string | null;
            description?: string | null;
            colour: string;
          }>;
        };
        attributes?: Array<{
          __typename?: 'Attribute';
          id: string;
          type: string;
          category?: string | null;
          name: string;
          value: Array<string>;
        }> | null;
        attribute?: {
          __typename?: 'AttributeTask';
          id: string;
          attributes: Array<string>;
        } | null;
        purchase?: {
          __typename?: 'PurchaseTask';
          id: string;
          spaces: Array<string>;
        } | null;
        stocktake?: {
          __typename?: 'Stocktake';
          id: string;
          include: Array<ItemType>;
          itemStatus: Array<Status>;
          spaces: Array<string>;
          items: Array<{
            __typename?: 'StocktakeItem';
            id: string;
            adjustment: number;
            newOnHand: number;
          }>;
        } | null;
        config?: {
          __typename?: 'AssetTaskConfig';
          selection: string;
          spaces: Array<string>;
          assetTypes: Array<string>;
          allow: Array<string>;
          shareAttributes: boolean;
          shareJobHistory: boolean;
          shareDeploymentHistory: boolean;
        } | null;
        assets: Array<{
          __typename?: 'Asset';
          id: string;
          name: string;
          type: string;
        }>;
      }>;
    };
    owners?: Array<{
      __typename?: 'Contact';
      id: string;
      name: string;
      image?: string | null;
    }> | null;
    assignees?: Array<{
      __typename?: 'Contact';
      id: string;
      name: string;
      image?: string | null;
    }> | null;
    conditions?: Array<{
      __typename?: 'AutomationCondition';
      type: string;
      operator: string;
      nights: number;
    }> | null;
    repeat?: {
      __typename?: 'AutomationRepeat';
      freq: string;
      interval: string;
      byday?: Array<string> | null;
      bymonthday?: Array<string> | null;
    } | null;
  }>;
};

export type AutomationFormQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AutomationFormQuery = {
  __typename?: 'Query';
  contacts: Array<
    { __typename?: 'Contact' } & {
      ' $fragmentRefs'?: { ContactFieldsFragment: ContactFieldsFragment };
    }
  >;
  jobTemplates: Array<
    { __typename?: 'JobTemplate' } & {
      ' $fragmentRefs'?: {
        JobTemplateFieldsFragment: JobTemplateFieldsFragment;
      };
    }
  >;
  automation?: {
    __typename?: 'Automation';
    id: string;
    status: Status;
    name: string;
    on: string;
    whereType: AutomationWhereType;
    jobName: string;
    day: number;
    time?: string | null;
    repeatStartDate?: any | null;
    maintainRepeats?: number | null;
    matchAttribute?: Array<{
      __typename?: 'Attribute';
      value: Array<string>;
      key: string;
    }> | null;
    sites: Array<{
      __typename?: 'Site';
      id: string;
      name: string;
      image?: string | null;
    }>;
    template: {
      __typename?: 'JobTemplate';
      id: string;
      status: Status;
      name: string;
      notes?: string | null;
      includeAttributes?: Array<string> | null;
      jobAttributeIds?: Array<string> | null;
      tags?: Array<{
        __typename?: 'Tag';
        id: string;
        entityType: string;
        category?: string | null;
        name: string;
        description?: string | null;
        colour: string;
      }> | null;
      attachments?: Array<{
        __typename?: 'Attachment';
        id: string;
        kind: string;
        ext: string;
        thumb: string;
        url: string;
        originalFilename: string;
      }> | null;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        type: string;
        name: string;
        description: string;
        jobAttributeIds?: Array<string> | null;
        attributes?: Array<{
          __typename?: 'Attribute';
          id: string;
          type: string;
          category?: string | null;
          name: string;
          value: Array<string>;
        }> | null;
        attribute?: {
          __typename?: 'AttributeTask';
          id: string;
          attributes: Array<string>;
        } | null;
        purchase?: {
          __typename?: 'PurchaseTask';
          id: string;
          spaces: Array<string>;
        } | null;
        stocktake?: {
          __typename?: 'Stocktake';
          id: string;
          include: Array<ItemType>;
          itemStatus: Array<Status>;
          spaces: Array<string>;
          items: Array<{
            __typename?: 'StocktakeItem';
            id: string;
            adjustment: number;
            newOnHand: number;
          }>;
        } | null;
        config?: {
          __typename?: 'AssetTaskConfig';
          selection: string;
          spaces: Array<string>;
          assetTypes: Array<string>;
          allow: Array<string>;
        } | null;
        assets: Array<{
          __typename?: 'Asset';
          id: string;
          name: string;
          type: string;
        }>;
      }>;
    };
    owners?: Array<{ __typename?: 'Contact'; id: string }> | null;
    assignees?: Array<{ __typename?: 'Contact'; id: string }> | null;
    repeat?: {
      __typename?: 'AutomationRepeat';
      freq: string;
      interval: string;
      byday?: Array<string> | null;
      bymonthday?: Array<string> | null;
    } | null;
  } | null;
};

export type ContactTypesPreset_ListFiltersQueryVariables = Exact<{
  preset?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ContactTypesPreset_ListFiltersQuery = {
  __typename?: 'Query';
  contactTypes: Array<string>;
};

export type UpdateDeploymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  images: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type UpdateDeploymentMutation = {
  __typename?: 'Mutation';
  updateDeployment: number;
};

export type GuestySetupMutationVariables = Exact<{
  integrationToken: Scalars['String']['input'];
}>;

export type GuestySetupMutation = {
  __typename?: 'Mutation';
  guestySetup?: string | null;
};

export type ItemsQueryVariables = Exact<{
  status?: InputMaybe<Array<Status> | Status>;
  inConfig?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ItemsQuery = {
  __typename?: 'Query';
  items: Array<
    { __typename?: 'Item'; id: string } & {
      ' $fragmentRefs'?: { ItemDataFragment: ItemDataFragment };
    }
  >;
};

export type ItemDataFragment = {
  __typename?: 'Item';
  id: string;
  status: Status;
  name: string;
  type: ItemType;
  description?: string | null;
  skuPrefix?: string | null;
  images: Array<string>;
  image?: string | null;
  activeSkus: number;
  hasVariants: boolean;
  attributes?: Array<
    { __typename?: 'Attribute' } & {
      ' $fragmentRefs'?: { AttributeFieldsFragment: AttributeFieldsFragment };
    }
  > | null;
  skus: Array<{
    __typename?: 'Sku';
    id: string;
    status: Status;
    _name?: string | null;
    name: string;
    code?: string | null;
    images: Array<string>;
    image?: string | null;
    variant: Array<{
      __typename?: 'VariantValue';
      name: string;
      value: string;
    }>;
  }>;
  variantTypes: Array<{
    __typename?: 'VariantType';
    name: string;
    values: Array<string>;
  }>;
} & { ' $fragmentName'?: 'ItemDataFragment' };

export type CreateJobTemplateFormQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CreateJobTemplateFormQuery = {
  __typename?: 'Query';
  integrations: Array<string>;
};

export type EditJobFormQueryVariables = Exact<{ [key: string]: never }>;

export type EditJobFormQuery = {
  __typename?: 'Query';
  integrations: Array<string>;
  attributes: Array<{
    __typename?: 'Attribute';
    id: string;
    type: string;
    category?: string | null;
    name: string;
    value: Array<string>;
    condition?: string | null;
  }>;
  jobTemplates: Array<
    { __typename?: 'JobTemplate' } & {
      ' $fragmentRefs'?: {
        JobTemplateFieldsFragment: JobTemplateFieldsFragment;
      };
    }
  >;
  contacts: Array<
    { __typename?: 'Contact' } & {
      ' $fragmentRefs'?: { ContactFieldsFragment: ContactFieldsFragment };
    }
  >;
};

export type JobCalendarEventsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type JobCalendarEventsQuery = {
  __typename?: 'Query';
  jobCalendarEvents: Array<
    { __typename?: 'JobCalendarEvent'; id: string } & {
      ' $fragmentRefs'?: {
        JobCalendarEventFieldsFragment: JobCalendarEventFieldsFragment;
      };
    }
  >;
};

export type JobStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type JobStatusQuery = {
  __typename?: 'Query';
  job?: {
    __typename?: 'Job';
    id: string;
    status: JobStatus;
    isScheduled: boolean;
  } | null;
};

export type ListJobsQueryVariables = Exact<{
  scheduled?: InputMaybe<Scalars['String']['input']>;
  dateAfter?: InputMaybe<Scalars['DateTime']['input']>;
  dateBefore?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<JobStatus> | JobStatus>;
  locationName?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  locationOwnerId?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  locationAttributes?: InputMaybe<Array<AttributeInput> | AttributeInput>;
  assignee?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  included?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  ofType?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type ListJobsQuery = {
  __typename?: 'Query';
  assignees: Array<{ __typename?: 'Contact'; id: string; name: string }>;
  tags: {
    __typename?: 'TagConnection';
    edges: Array<{
      __typename?: 'TagEdge';
      node: {
        __typename?: 'Tag';
        id: string;
        name: string;
        category?: string | null;
        description?: string | null;
        colour: string;
      };
    }>;
  };
  jobBoard: Array<
    | {
        __typename: 'Job';
        id: string;
        status: JobStatus;
        name: string;
        createdAt: any;
        scheduleStart?: any | null;
        scheduleEnd?: any | null;
        scheduledStartStrict: boolean;
        scheduledStartDate?: any | null;
        scheduledStartTime?: any | null;
        scheduledEndStrict: boolean;
        scheduledEndDate?: any | null;
        scheduledEndTime?: any | null;
        completedAt?: any | null;
        timeZone: string;
        image?: string | null;
        jobTags?: Array<{
          __typename?: 'Tag';
          id: string;
          entityType: string;
          name: string;
          category?: string | null;
          description?: string | null;
          colour: string;
        }> | null;
        location?:
          | { __typename: 'Asset'; id: string; name: string }
          | { __typename: 'Contact'; id: string; name: string }
          | { __typename: 'Elsewhere'; id: string; name: string }
          | { __typename: 'Fsp'; id: string; name: string }
          | {
              __typename: 'Site';
              id: string;
              name: string;
              licensor?: {
                __typename?: 'Organisation';
                id: string;
                name: string;
              } | null;
            }
          | { __typename: 'StockTransfer'; id: string; name: string }
          | null;
        assignees?: Array<{
          __typename?: 'Contact';
          id: string;
          name: string;
          image?: string | null;
        }> | null;
        occupied?: {
          __typename?: 'Booking';
          id: string;
          checkIn: any;
          checkOut: any;
        } | null;
        prevCheckOut?: {
          __typename?: 'Booking';
          id: string;
          checkIn: any;
          checkOut: any;
        } | null;
        nextCheckIn?: {
          __typename?: 'Booking';
          id: string;
          checkIn: any;
          checkOut: any;
        } | null;
      }
    | ({
        __typename: 'JobCalendarEvent';
        id: string;
        hidden: boolean;
        summary: string;
        start: any;
        end?: any | null;
      } & {
        ' $fragmentRefs'?: {
          JobCalendarEventFieldsFragment: JobCalendarEventFieldsFragment;
        };
      })
  >;
};

export type SitesQueryVariables = Exact<{ [key: string]: never }>;

export type SitesQuery = {
  __typename?: 'Query';
  sites: Array<{
    __typename?: 'Site';
    id: string;
    status: Status;
    type?: string | null;
    name: string;
    address?: string | null;
    state?: string | null;
    image?: string | null;
    activeLocations: number;
    attributes?: Array<{
      __typename?: 'Attribute';
      id: string;
      type: string;
      category?: string | null;
      name: string;
      value: Array<string>;
    }> | null;
  }>;
};

export type SiteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SiteQuery = {
  __typename?: 'Query';
  integrations: Array<string>;
  site: {
    __typename?: 'Site';
    id: string;
    status: Status;
    name: string;
    type?: string | null;
    address?: string | null;
    image?: string | null;
    notes?: string | null;
    images: Array<string>;
    airbnbDefaultCheckIn?: string | null;
    airbnbDefaultCheckOut?: string | null;
    licensor?: { __typename?: 'Organisation'; id: string; name: string } | null;
    defaultSource?: {
      __typename?: 'Site';
      id: string;
      type?: string | null;
      name: string;
    } | null;
    attributes?: Array<
      { __typename?: 'Attribute' } & {
        ' $fragmentRefs'?: { AttributeFieldsFragment: AttributeFieldsFragment };
      }
    > | null;
    integrationAttributes?: Array<{
      __typename?: 'Attribute';
      name: string;
      value: Array<string>;
    }> | null;
    airbnbCalendar?: Array<{
      __typename?: 'CalendarSubscription';
      id: string;
      provider?: string | null;
      url: string;
      syncedAt?: any | null;
    }> | null;
    homhero?: { __typename?: 'HomheroArea'; id: string; name: string } | null;
  };
};

export type SiteFormQueryVariables = Exact<{ [key: string]: never }>;

export type SiteFormQuery = {
  __typename?: 'Query';
  integrations: Array<string>;
  homheroAreas?: Array<{
    __typename?: 'HomheroArea';
    id: string;
    name: string;
  }> | null;
};

export const ScheduleEventStartEndFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleEventStartEnd' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScheduleEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'end' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleEventStartEndFragment, unknown>;
export const ScheduleEventTimesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleEventTimes' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScheduleEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'end' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartTime' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEndTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleEventTimesFragment, unknown>;
export const ScheduleEventStatusFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleEventStatus' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScheduleEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleEventStatusFragment, unknown>;
export const ScheduleEventFullFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduleEventFull' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScheduleEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'end' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartTime' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEndTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleEventFullFragment, unknown>;
export const JobTimesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTimes' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Job' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartDate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartTime' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEndDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEndTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartStrict' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledEndStrict' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobTimesFragment, unknown>;
export const DeploymentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeploymentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Deployment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'space' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeploymentFieldsFragment, unknown>;
export const Attribute_AttachmentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Attribute_AttachmentFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalFilename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Attribute_AttachmentFragmentFragment, unknown>;
export const Attribute_AttributeFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Attribute_AttributeFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          { kind: 'Field', name: { kind: 'Name', value: 'options' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Attribute_AttachmentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Attribute_AttachmentFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalFilename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Attribute_AttributeFragmentFragment, unknown>;
export const GlobalAttributes_QueryFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GlobalAttributes_QueryFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Query' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'entityType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Attribute_AttributeFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Attribute_AttachmentFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalFilename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Attribute_AttributeFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          { kind: 'Field', name: { kind: 'Name', value: 'options' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Attribute_AttachmentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GlobalAttributes_QueryFragmentFragment, unknown>;
export const TagFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TagFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Tag' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TagFieldsFragment, unknown>;
export const ActivityListItem_TagFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActivityListItem_TagFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Tag' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivityListItem_TagFragmentFragment, unknown>;
export const ActivityListItem_ActivityFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActivityListItem_ActivityFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Activity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRead' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFlagged' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ActivityListItem_TagFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'job' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'site' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobTags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ActivityListItem_TagFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'task' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ActivityListItem_TagFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originalFilename' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originalFilename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ActivityListItem_TagFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inputDate' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActivityListItem_TagFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Tag' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActivityListItem_ActivityFragmentFragment,
  unknown
>;
export const JobCalendarEventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobCalendarEventFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobCalendarEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'end' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cancelled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduleStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleEnd' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartTime' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndTime' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobCalendarEventFieldsFragment, unknown>;
export const Feed_CommentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Feed_Comment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Comment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRead' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFlagged' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Feed_CommentFragment, unknown>;
export const Feed_JobHistoryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Feed_JobHistory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobHistory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'task' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inputDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Feed_JobHistoryFragment, unknown>;
export const AttributeTaskFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeTask' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Task' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attribute' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttributeTaskFragment, unknown>;
export const TaskDataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskData' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Task' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colour' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'jobAttributeIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'model' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deployment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayLocation' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'space' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'config' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'selection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareAttributes' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareJobHistory' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareDeploymentHistory' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AttributeTask' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'purchase' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'movements' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qty' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stocktake' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'include' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stockTransfer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceString' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destinationString' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeTask' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Task' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attribute' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskDataFragment, unknown>;
export const SiteJobs_JobFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SiteJobs_Job' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Job' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartStrict' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartDate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartTime' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledEndStrict' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEndDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEndTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteJobs_JobFragment, unknown>;
export const AttachmentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalFilename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttachmentFieldsFragment, unknown>;
export const ContactFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Contact' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamMember' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactFieldsFragment, unknown>;
export const StocktakeTaskFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StocktakeTaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Stocktake' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'include' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adjustment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newOnHand' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StocktakeTaskFieldsFragment, unknown>;
export const JobTemplateFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTemplateFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobTemplate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStarter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'behavior' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quickCreate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAttributes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobAttributeIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestyCleaningStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobAttributeIds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attribute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'purchase' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stocktake' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StocktakeTaskFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetTypes' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareAttributes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareJobHistory' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareDeploymentHistory' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StocktakeTaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Stocktake' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'include' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adjustment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newOnHand' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobTemplateFieldsFragment, unknown>;
export const AttributeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttributeFieldsFragment, unknown>;
export const ItemDataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'itemData' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Item' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'skuPrefix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'images' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activeSkus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVariants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttributeFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skus' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: '_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'images' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'variant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'variantTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'values' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ItemDataFragment, unknown>;
export const ContactTypeConfig_CacheDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypeConfig_Cache' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypeConfig_CacheQuery,
  ContactTypeConfig_CacheQueryVariables
>;
export const AssetTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssetTypes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'assetTypes' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssetTypesQuery, AssetTypesQueryVariables>;
export const SiteAttributesData_QueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SiteAttributesData_Query' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entityType' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          defaultValue: { kind: 'StringValue', value: 'Site', block: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'GlobalAttributes_QueryFragment' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Attribute_AttachmentFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalFilename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Attribute_AttributeFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          { kind: 'Field', name: { kind: 'Name', value: 'options' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Attribute_AttachmentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GlobalAttributes_QueryFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Query' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'entityType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Attribute_AttributeFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SiteAttributesData_QueryQuery,
  SiteAttributesData_QueryQueryVariables
>;
export const CreateContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContactInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationship' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCurrentUser' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isTeamMember' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateContactMutation,
  CreateContactMutationVariables
>;
export const ListSitesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListSites' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sites' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeLocations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListSitesQuery, ListSitesQueryVariables>;
export const RescheduleJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RescheduleJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RescheduleJobInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rescheduleJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduleStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleEnd' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartTime' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndTime' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RescheduleJobMutation,
  RescheduleJobMutationVariables
>;
export const CreateTagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTagInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTag' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TagFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TagFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Tag' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTagInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTag' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TagFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TagFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Tag' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteTagInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTag' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTagMutation, DeleteTagMutationVariables>;
export const ListTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entityTypes' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityTypes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'entityTypes' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListTagsQuery, ListTagsQueryVariables>;
export const FlagMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FlagMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'flagged' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flagMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'flagged' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'flagged' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FlagMessageMutation, FlagMessageMutationVariables>;
export const MarkAsReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkAsRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markAsRead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkAsReadMutation, MarkAsReadMutationVariables>;
export const MarkAllAsReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkAllAsRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'before' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markAllAsRead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'before' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkAllAsReadMutation,
  MarkAllAsReadMutationVariables
>;
export const UpdateAttributeValuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAttributeValues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAttributeValuesInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAttributeValues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttributeFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAttributeValuesMutation,
  UpdateAttributeValuesMutationVariables
>;
export const GetSiteForContextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSiteForContext' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'site' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSiteForContextQuery,
  GetSiteForContextQueryVariables
>;
export const AssetTypeConfigForFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssetTypeConfigForForm' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetTypeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssetTypeConfigForFormQuery,
  AssetTypeConfigForFormQueryVariables
>;
export const AssetRuleTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssetRuleTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'behavior' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TemplateBehavior' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'behavior' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'behavior' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'behavior' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quickCreate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'config' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'assetTypes' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssetRuleTemplatesQuery,
  AssetRuleTemplatesQueryVariables
>;
export const AssetDeploymentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssetDeployments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'jobId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taskId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deployments' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'jobId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'jobId' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'taskId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'taskId' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayLocation' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssetDeploymentsQuery,
  AssetDeploymentsQueryVariables
>;
export const OtpGenerateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OtpGenerate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OtpGenerateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otpGenerate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OtpGenerateMutation, OtpGenerateMutationVariables>;
export const OtpVerifyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OtpVerify' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OtpVerifyInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otpVerify' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OtpVerifyMutation, OtpVerifyMutationVariables>;
export const CreateJobTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateJobTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'JobTemplateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createJobTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateJobTemplateMutation,
  CreateJobTemplateMutationVariables
>;
export const RescheduleJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RescheduleJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RescheduleJobsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rescheduleJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduleStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleEnd' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartTime' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndTime' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RescheduleJobsMutation,
  RescheduleJobsMutationVariables
>;
export const ContactTypeMappingsForShortFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypeMappingsForShortForm' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypeMappings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationships' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypeMappingsForShortFormQuery,
  ContactTypeMappingsForShortFormQueryVariables
>;
export const ContactTypeConfig_ForFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypeConfig_ForForm' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypeConfig_ForFormQuery,
  ContactTypeConfig_ForFormQueryVariables
>;
export const ContactTypesPreset_ForFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypesPreset_ForForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'preset' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preset' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'preset' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypesPreset_ForFormQuery,
  ContactTypesPreset_ForFormQueryVariables
>;
export const ContactTypesInUse_ForFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypesInUse_ForForm' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contactTypesInUse' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypesInUse_ForFormQuery,
  ContactTypesInUse_ForFormQueryVariables
>;
export const ContactTypeMappingsForFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypeMappingsForForm' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypeMappings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationships' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypeMappingsForFormQuery,
  ContactTypeMappingsForFormQueryVariables
>;
export const AllContactsForTypes_FormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllContactsForTypes_Form' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'EnumValue', value: 'Active' },
                    { kind: 'EnumValue', value: 'Inactive' },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationship' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllContactsForTypes_FormQuery,
  AllContactsForTypes_FormQueryVariables
>;
export const ContactTypeMappingsForListItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypeMappingsForListItem' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypeMappings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationships' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypeMappingsForListItemQuery,
  ContactTypeMappingsForListItemQueryVariables
>;
export const ContactTypesPreset_ForListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypesPreset_ForList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'preset' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preset' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'preset' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypesPreset_ForListQuery,
  ContactTypesPreset_ForListQueryVariables
>;
export const ContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Contact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organisation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationship' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'streetAddress' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'postalAddress' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AttributeFields' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'images' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCurrentUser' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactQuery, ContactQueryVariables>;
export const ContactTypeMappingsForViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypeMappingsForView' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypeMappings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationships' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypeMappingsForViewQuery,
  ContactTypeMappingsForViewQueryVariables
>;
export const AttributeSelectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AttributeSelect' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entityType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrations' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'entityType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AttributeSelectQuery,
  AttributeSelectQueryVariables
>;
export const AssignJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AssignJobsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owners' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'include' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignJobsMutation, AssignJobsMutationVariables>;
export const CancelJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelJobsMutation, CancelJobsMutationVariables>;
export const CompleteJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompleteJobsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteJobsMutation,
  CompleteJobsMutationVariables
>;
export const AddTagsToJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTagsToJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'jobIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tagIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTagsToJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'jobIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tagIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobTags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddTagsToJobsMutation,
  AddTagsToJobsMutationVariables
>;
export const RemoveTagsFromJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveTagsFromJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'jobIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tagIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeTagsFromJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'jobIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tagIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobTags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveTagsFromJobsMutation,
  RemoveTagsFromJobsMutationVariables
>;
export const JobTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobTemplatesQuery, JobTemplatesQueryVariables>;
export const UpdateJobTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateJobTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'jobIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'templateId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateJobTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'jobIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'templateId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateJobTemplatesMutation,
  UpdateJobTemplatesMutationVariables
>;
export const CreateJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateJobInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndDate' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateJobsMutation, CreateJobsMutationVariables>;
export const CreateAutomationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAutomation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutomationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAutomation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAutomationMutation,
  CreateAutomationMutationVariables
>;
export const AssetSharingDefaultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssetSharingDefaults' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetSharingDefaults' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareAttributes' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareJobHistory' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareDeploymentHistory' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssetSharingDefaultsQuery,
  AssetSharingDefaultsQueryVariables
>;
export const UpdateJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateJobInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AttachmentFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduleStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleEnd' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enforceOrder' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TaskData' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeTask' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Task' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attribute' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalFilename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskData' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Task' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colour' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'jobAttributeIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'model' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deployment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayLocation' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'space' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'config' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'selection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareAttributes' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareJobHistory' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareDeploymentHistory' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AttributeTask' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'purchase' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'movements' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qty' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stocktake' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'include' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stockTransfer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceString' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destinationString' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateJobMutation, UpdateJobMutationVariables>;
export const HideJobCalendarEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'HideJobCalendarEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hideJobCalendarEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HideJobCalendarEventMutation,
  HideJobCalendarEventMutationVariables
>;
export const CompleteJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'endTime' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DateTime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'attributes' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'AttributeInputV2' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endTime' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'endTime' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'attributes' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteJobMutation, CompleteJobMutationVariables>;
export const FeedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Feed' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'job' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'comments' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'last' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'last' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'Comment' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tags' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entityType' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'colour' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'JobHistory' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'taskId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'task' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'notes' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'attachments',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'kind' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'thumb',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'url' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'originalFilename',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Feed_Comment' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Feed_JobHistory' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Feed_Comment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Comment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRead' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFlagged' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Feed_JobHistory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobHistory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'task' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inputDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeedQuery, FeedQueryVariables>;
export const AddCommentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddComment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddCommentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addComment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originalFilename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colour' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCommentMutation, AddCommentMutationVariables>;
export const RevertJobStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RevertJobStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'currentStatus' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'JobStatus' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'comment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revertJobStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'currentStatus' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'currentStatus' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'comment' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'comment' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RevertJobStatusMutation,
  RevertJobStatusMutationVariables
>;
export const AddTagsToJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTagsToJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tagIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTagsToJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tagIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobTags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddTagsToJobMutation,
  AddTagsToJobMutationVariables
>;
export const RemoveTagsFromJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveTagsFromJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tagIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeTagsFromJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tagIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobTags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveTagsFromJobMutation,
  RemoveTagsFromJobMutationVariables
>;
export const UpdateJobAssigneeNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateJobAssigneeNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assigneeNotes' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateJobAssigneeNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assigneeNotes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'assigneeNotes' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assigneeNotes' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateJobAssigneeNotesMutation,
  UpdateJobAssigneeNotesMutationVariables
>;
export const JobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Job' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'job' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduleStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleEnd' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartTime' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndTime' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kind' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ext' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumb' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'originalFilename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobAttributeIds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobAttributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobTags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colour' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assigneeNotes' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originalFilename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enforceOrder' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'include' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owners' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canAcceptOffer' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deployment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayLocation' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'separator' },
                                  value: {
                                    kind: 'StringValue',
                                    value: ' / ',
                                    block: false,
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'Site' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'required' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TaskData' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'booking' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'occupied' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkIn' },
                        name: { kind: 'Name', value: 'start' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkOut' },
                        name: { kind: 'Name', value: 'end' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prevCheckOut' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkIn' },
                        name: { kind: 'Name', value: 'start' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkOut' },
                        name: { kind: 'Name', value: 'end' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextCheckIn' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkIn' },
                        name: { kind: 'Name', value: 'start' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkOut' },
                        name: { kind: 'Name', value: 'end' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'guestyCleaningStatus' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'site' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'occupied' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkIn' },
                        name: { kind: 'Name', value: 'start' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkOut' },
                        name: { kind: 'Name', value: 'end' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prevCheckOut' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkIn' },
                        name: { kind: 'Name', value: 'start' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkOut' },
                        name: { kind: 'Name', value: 'end' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextCheckIn' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkIn' },
                        name: { kind: 'Name', value: 'start' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'checkOut' },
                        name: { kind: 'Name', value: 'end' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeTask' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Task' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attribute' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskData' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Task' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colour' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'jobAttributeIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'model' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deployment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayLocation' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'space' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'config' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'selection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareAttributes' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareJobHistory' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareDeploymentHistory' },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AttributeTask' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'purchase' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'movements' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qty' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stocktake' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'include' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stockTransfer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceString' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destinationString' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobQuery, JobQueryVariables>;
export const SiteAttributesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SiteAttributes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'site' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'Attribute_AttributeFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Attribute_AttachmentFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalFilename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Attribute_AttributeFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          { kind: 'Field', name: { kind: 'Name', value: 'options' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Attribute_AttachmentFragment' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteAttributesQuery, SiteAttributesQueryVariables>;
export const AddTagsToTaggableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTagsToTaggable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddTagsToTaggableInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTagsToTaggable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Task' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddTagsToTaggableMutation,
  AddTagsToTaggableMutationVariables
>;
export const RemoveTagsFromTaggableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveTagsFromTaggable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemoveTagsFromTaggableInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeTagsFromTaggable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Task' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveTagsFromTaggableMutation,
  RemoveTagsFromTaggableMutationVariables
>;
export const CompleteCustomTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteCustomTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompleteTaskInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeCustomTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'job' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteCustomTaskMutation,
  CompleteCustomTaskMutationVariables
>;
export const AdvanceTenantOnboardingStepDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AdvanceTenantOnboardingStep' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'flowKey' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'totalSteps' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'advanceTenantOnboardingStep' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'flowKey' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'flowKey' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'totalSteps' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'totalSteps' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'flowKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedByUserId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdvanceTenantOnboardingStepMutation,
  AdvanceTenantOnboardingStepMutationVariables
>;
export const OnboardingListJobTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OnboardingListJobTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Status' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isStarter' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobAttributeIds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entityType' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'colour' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'config' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'selection' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'spaces' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'assetTypes' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'allow' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shareAttributes' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shareJobHistory' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'shareDeploymentHistory',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attribute' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attributes' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnboardingListJobTemplatesQuery,
  OnboardingListJobTemplatesQueryVariables
>;
export const SpacesByLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SpacesByLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'spaces' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SpacesByLocationQuery,
  SpacesByLocationQueryVariables
>;
export const SiteJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SiteJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'scheduled' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'site' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobs' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'scheduled' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'scheduled' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'after' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'first' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cursor' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'SiteJobs_Job',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasNextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endCursor' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SiteJobs_Job' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Job' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartStrict' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartDate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledStartTime' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledEndStrict' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEndDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledEndTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteJobsQuery, SiteJobsQueryVariables>;
export const CompletePurchaseTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompletePurchaseTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompletePurchaseTaskInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completePurchaseTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompletePurchaseTaskMutation,
  CompletePurchaseTaskMutationVariables
>;
export const ListIntegrationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListIntegrations' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrations' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListIntegrationsQuery,
  ListIntegrationsQueryVariables
>;
export const AssetTypeConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssetTypeConfig' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetTypeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssetTypeConfigQuery,
  AssetTypeConfigQueryVariables
>;
export const UpdateAssetTypeConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAssetTypeConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePlaceTypeConfigInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAssetTypeConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAssetTypeConfigMutation,
  UpdateAssetTypeConfigMutationVariables
>;
export const AssetTypeCounts_LiveCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssetTypeCounts_LiveCheck' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetTypeCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUntypedAssets' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssetTypeCounts_LiveCheckQuery,
  AssetTypeCounts_LiveCheckQueryVariables
>;
export const AllAssetsFreshDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllAssetsFresh' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllAssetsFreshQuery, AllAssetsFreshQueryVariables>;
export const AssetTypeConfig_NavDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssetTypeConfig_Nav' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetTypeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssetTypeConfig_NavQuery,
  AssetTypeConfig_NavQueryVariables
>;
export const AssetTypeCounts_NavDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssetTypeCounts_Nav' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetTypeCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUntypedAssets' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssetTypeCounts_NavQuery,
  AssetTypeCounts_NavQueryVariables
>;
export const AllAssetsFresh_SingleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllAssetsFresh_Single' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllAssetsFresh_SingleQuery,
  AllAssetsFresh_SingleQueryVariables
>;
export const AllAssetsFresh_Rename2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllAssetsFresh_Rename2' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllAssetsFresh_Rename2Query,
  AllAssetsFresh_Rename2QueryVariables
>;
export const AllAssetsFresh_BulkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllAssetsFresh_Bulk' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllAssetsFresh_BulkQuery,
  AllAssetsFresh_BulkQueryVariables
>;
export const ContactTypeConfig_RelationshipsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypeConfig_Relationships' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypeConfig_RelationshipsQuery,
  ContactTypeConfig_RelationshipsQueryVariables
>;
export const ContactsByRelationshipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactsByRelationship' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'relationship' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relationship' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'relationship' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationship' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsByRelationshipQuery,
  ContactsByRelationshipQueryVariables
>;
export const ContactsRelless_LiveCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactsRelless_LiveCheck' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasUntypedContacts' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'contactTypesInUse' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsRelless_LiveCheckQuery,
  ContactsRelless_LiveCheckQueryVariables
>;
export const ContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Contacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'Status' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'relationship' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relationship' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'relationship' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationship' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCurrentUser' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isTeamMember' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactsQuery, ContactsQueryVariables>;
export const ContactTypeMappingsForListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypeMappingsForList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypeMappings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationships' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypeMappingsForListQuery,
  ContactTypeMappingsForListQueryVariables
>;
export const UpdateContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContactInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationship' },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateContactMutation,
  UpdateContactMutationVariables
>;
export const ContactTypesPresetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypesPreset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'preset' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preset' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'preset' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypesPresetQuery,
  ContactTypesPresetQueryVariables
>;
export const ContactTypesInUseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypesInUse' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contactTypesInUse' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypesInUseQuery,
  ContactTypesInUseQueryVariables
>;
export const AllContactsForTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllContactsForTypes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'EnumValue', value: 'Active' },
                    { kind: 'EnumValue', value: 'Inactive' },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationship' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllContactsForTypesQuery,
  AllContactsForTypesQueryVariables
>;
export const UpdateContactTypeConfig_RelationshipsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContactTypeConfig_Relationships' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePlaceTypeConfigInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContactTypeConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateContactTypeConfig_RelationshipsMutation,
  UpdateContactTypeConfig_RelationshipsMutationVariables
>;
export const AllContactsFresh_BulkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllContactsFresh_Bulk' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'EnumValue', value: 'Active' },
                    { kind: 'EnumValue', value: 'Inactive' },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationship' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllContactsFresh_BulkQuery,
  AllContactsFresh_BulkQueryVariables
>;
export const ContactsRelless_NavDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactsRelless_Nav' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasUntypedContacts' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'contactTypesInUse' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsRelless_NavQuery,
  ContactsRelless_NavQueryVariables
>;
export const AllContactsFreshDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllContactsFresh' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'EnumValue', value: 'Active' },
                    { kind: 'EnumValue', value: 'Inactive' },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationship' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllContactsFreshQuery,
  AllContactsFreshQueryVariables
>;
export const AllContactsFresh_SingleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllContactsFresh_Single' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'EnumValue', value: 'Active' },
                    { kind: 'EnumValue', value: 'Inactive' },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relationship' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllContactsFresh_SingleQuery,
  AllContactsFresh_SingleQueryVariables
>;
export const AllSitesFreshDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllSitesFresh' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sites' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'images' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licensor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultSource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'homhero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'airbnbCalendar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'airbnbDefaultCheckIn' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'airbnbDefaultCheckOut' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllSitesFreshQuery, AllSitesFreshQueryVariables>;
export const SiteTypeCounts_RefreshDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SiteTypeCounts_Refresh' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'siteTypeCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SiteTypeCounts_RefreshQuery,
  SiteTypeCounts_RefreshQueryVariables
>;
export const PlaceTypeConfig_RefreshDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PlaceTypeConfig_Refresh' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeTypeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlaceTypeConfig_RefreshQuery,
  PlaceTypeConfig_RefreshQueryVariables
>;
export const UpdatePlaceTypeConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePlaceTypeConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePlaceTypeConfigInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePlaceTypeConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaceTypeConfigMutation,
  UpdatePlaceTypeConfigMutationVariables
>;
export const RenamePlaceTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RenamePlaceType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renamePlaceType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'from' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'from' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'to' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'to' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RenamePlaceTypeMutation,
  RenamePlaceTypeMutationVariables
>;
export const SiteTypeCounts_LiveCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SiteTypeCounts_LiveCheck' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'siteTypeCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SiteTypeCounts_LiveCheckQuery,
  SiteTypeCounts_LiveCheckQueryVariables
>;
export const PlaceTypeConfig_Nav_ForceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PlaceTypeConfig_Nav_Force' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeTypeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCustomized' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlaceTypeConfig_Nav_ForceQuery,
  PlaceTypeConfig_Nav_ForceQueryVariables
>;
export const SiteTypeCounts_ForceRefresh_MultiDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SiteTypeCounts_ForceRefresh_Multi' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'siteTypeCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SiteTypeCounts_ForceRefresh_MultiQuery,
  SiteTypeCounts_ForceRefresh_MultiQueryVariables
>;
export const SiteTypeCounts_ForceRefresh_PlaceSingleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SiteTypeCounts_ForceRefresh_PlaceSingle' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'siteTypeCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SiteTypeCounts_ForceRefresh_PlaceSingleQuery,
  SiteTypeCounts_ForceRefresh_PlaceSingleQueryVariables
>;
export const SiteTypeCounts_ForceRefresh2_PlaceBgDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SiteTypeCounts_ForceRefresh2_PlaceBg' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'siteTypeCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SiteTypeCounts_ForceRefresh2_PlaceBgQuery,
  SiteTypeCounts_ForceRefresh2_PlaceBgQueryVariables
>;
export const UpdateAssetSharingDefaultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAssetSharingDefaults' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AssetSharingDefaultsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAssetSharingDefaults' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareAttributes' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareJobHistory' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareDeploymentHistory' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAssetSharingDefaultsMutation,
  UpdateAssetSharingDefaultsMutationVariables
>;
export const UpdateJobTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateJobTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'JobTemplateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateJobTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobTemplateFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StocktakeTaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Stocktake' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'include' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adjustment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newOnHand' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTemplateFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobTemplate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStarter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'behavior' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quickCreate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAttributes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobAttributeIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestyCleaningStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobAttributeIds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attribute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'purchase' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stocktake' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StocktakeTaskFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetTypes' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareAttributes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareJobHistory' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareDeploymentHistory' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateJobTemplateMutation,
  UpdateJobTemplateMutationVariables
>;
export const ScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Schedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'names' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityTypes' },
                value: { kind: 'StringValue', value: 'Job', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colour' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'assignees' },
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sites' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'names' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'names' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'calendarBounds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'calendar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledStartTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledEndTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeZone' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'included' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleQuery, ScheduleQueryVariables>;
export const TaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Task' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'task' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kind' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ext' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumb' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'originalFilename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobAttributeIds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taskAttributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AttachmentFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'job' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetTypes' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareAttributes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareJobHistory' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareDeploymentHistory' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'model' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deployment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'space' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'purchase' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'movements' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'qty' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stocktake' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'include' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemStatus' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'adjustment' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newOnHand' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stockTransfer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rule' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'spaceId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'skuId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pick' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'picked' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'packed' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dispatched' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'received' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'putAway' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transfer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'available' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'qty' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'moved' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'qty' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stockOnHand' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reserved' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'soh' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'target' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'capacity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reorderLevel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'space' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sku' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'code' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'itemType' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttributeTask' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'originalFilename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeTask' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Task' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attribute' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskQuery, TaskQueryVariables>;
export const ListJobTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListJobTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Status' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobTemplateFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StocktakeTaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Stocktake' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'include' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adjustment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newOnHand' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTemplateFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobTemplate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStarter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'behavior' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quickCreate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAttributes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobAttributeIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestyCleaningStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobAttributeIds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attribute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'purchase' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stocktake' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StocktakeTaskFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetTypes' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareAttributes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareJobHistory' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareDeploymentHistory' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListJobTemplatesQuery,
  ListJobTemplatesQueryVariables
>;
export const ContactNavConfig_NavDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactNavConfig_Nav' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'navTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAllInNav' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactNavConfig_NavQuery,
  ContactNavConfig_NavQueryVariables
>;
export const ContactTypesPreset_NavDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypesPreset_Nav' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'preset' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preset' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'preset' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypesPreset_NavQuery,
  ContactTypesPreset_NavQueryVariables
>;
export const ActivityNav_TotalCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivityNav_TotalCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showMessages' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showStatus' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showTaskNotes' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'unread' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'flagged' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'site' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'author' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dateRange' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tag' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showMessages' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'showMessages' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showStatus' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'showStatus' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showTaskNotes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'showTaskNotes' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'unread' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'unread' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'flagged' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'flagged' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'site' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'site' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'author' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'author' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dateRange' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tag' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tag' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActivityNav_TotalCountQuery,
  ActivityNav_TotalCountQueryVariables
>;
export const AddTagsToActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTagsToActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tagIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTagsToActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tagIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colour' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddTagsToActivityMutation,
  AddTagsToActivityMutationVariables
>;
export const RemoveTagsFromActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveTagsFromActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tagIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeTagsFromActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tagIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colour' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveTagsFromActivityMutation,
  RemoveTagsFromActivityMutationVariables
>;
export const ActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Activity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showMessages' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showStatus' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showTaskNotes' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'unread' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'flagged' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'site' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'author' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dateRange' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tag' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'commentTagIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'jobTagIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taskTagIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'excludeAutomation' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityTypes' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'StringValue', value: 'Activity', block: false },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colour' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showMessages' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'showMessages' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showStatus' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'showStatus' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showTaskNotes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'showTaskNotes' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'unread' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'unread' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'flagged' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'flagged' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'site' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'site' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'author' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'author' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dateRange' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tag' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tag' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'commentTagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'commentTagIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobTagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'jobTagIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskTagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'taskTagIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'excludeAutomation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'excludeAutomation' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalUnreadCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ActivityListItem_ActivityFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cursor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActivityListItem_TagFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Tag' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActivityListItem_ActivityFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Activity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRead' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFlagged' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ActivityListItem_TagFragment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'job' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'site' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobTags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ActivityListItem_TagFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'task' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ActivityListItem_TagFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originalFilename' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originalFilename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ActivityListItem_TagFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inputDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivityQuery, ActivityQueryVariables>;
export const Activities_TotalCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Activities_TotalCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showMessages' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showStatus' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showTaskNotes' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'unread' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'flagged' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'site' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'author' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dateRange' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tag' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'commentTagIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'jobTagIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taskTagIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'excludeAutomation' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showMessages' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'showMessages' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showStatus' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'showStatus' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showTaskNotes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'showTaskNotes' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'unread' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'unread' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'flagged' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'flagged' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'site' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'site' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'author' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'author' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dateRange' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tag' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tag' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'commentTagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'commentTagIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobTagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'jobTagIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskTagIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'taskTagIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'excludeAutomation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'excludeAutomation' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Activities_TotalCountQuery,
  Activities_TotalCountQueryVariables
>;
export const ActivityUnreadCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivityUnreadCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allActivity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalUnreadCount' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActivityUnreadCountQuery,
  ActivityUnreadCountQueryVariables
>;
export const AssetJobsRouteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssetJobsRoute' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '_dateScheduled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduleStart' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduleEnd' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledStartStrict' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledStartDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledStartTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledEndStrict' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledEndDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledEndTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeZone' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssetJobsRouteQuery, AssetJobsRouteQueryVariables>;
export const CreateJobFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateJobForm' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrations' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'StringValue', value: 'Site', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'jobNameOptions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobTemplateFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Asset' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deployment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayLocation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'defaultSourceId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContactFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StocktakeTaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Stocktake' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'include' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adjustment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newOnHand' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTemplateFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobTemplate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStarter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'behavior' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quickCreate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAttributes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobAttributeIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestyCleaningStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobAttributeIds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attribute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'purchase' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stocktake' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StocktakeTaskFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetTypes' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareAttributes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareJobHistory' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareDeploymentHistory' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Contact' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamMember' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateJobFormQuery, CreateJobFormQueryVariables>;
export const UpdateAutomationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAutomation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutomationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutomation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAutomationMutation,
  UpdateAutomationMutationVariables
>;
export const GetAllJobTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllJobTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobTemplateFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StocktakeTaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Stocktake' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'include' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adjustment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newOnHand' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTemplateFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobTemplate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStarter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'behavior' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quickCreate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAttributes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobAttributeIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestyCleaningStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobAttributeIds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attribute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'purchase' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stocktake' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StocktakeTaskFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetTypes' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareAttributes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareJobHistory' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareDeploymentHistory' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllJobTemplatesQuery,
  GetAllJobTemplatesQueryVariables
>;
export const ListAutomationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListAutomations' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'automations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'on' } },
                { kind: 'Field', name: { kind: 'Name', value: 'whereType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'matchAttribute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'key' },
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sites' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'do' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'template' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'includeAttributes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobAttributeIds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kind' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ext' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumb' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'originalFilename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestyCleaningStatus' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tasks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tags' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'entityType',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'category',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'colour',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attributes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'jobAttributeIds' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attribute' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'purchase' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spaces' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stocktake' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'include' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'itemStatus' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spaces' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'adjustment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'newOnHand',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'config' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'selection' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spaces' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assetTypes' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'allow' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'shareAttributes',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'shareJobHistory',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'shareDeploymentHistory',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'assets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owners' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conditions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nights' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'repeatUntilOffset' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'repeatStartDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'repeat' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'freq' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'interval' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'byday' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bymonthday' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'maintainRepeats' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListAutomationsQuery,
  ListAutomationsQueryVariables
>;
export const AutomationFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AutomationForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContactFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobTemplateFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'automation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'on' } },
                { kind: 'Field', name: { kind: 'Name', value: 'whereType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'matchAttribute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'key' },
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sites' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'template' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'includeAttributes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobAttributeIds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kind' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ext' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumb' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'originalFilename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tasks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attributes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'jobAttributeIds' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attribute' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'purchase' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spaces' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stocktake' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'include' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'itemStatus' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spaces' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'adjustment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'newOnHand',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'config' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'selection' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spaces' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assetTypes' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'allow' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'assets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owners' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'repeatStartDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'repeat' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'freq' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'interval' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'byday' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bymonthday' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'maintainRepeats' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StocktakeTaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Stocktake' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'include' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adjustment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newOnHand' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Contact' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamMember' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTemplateFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobTemplate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStarter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'behavior' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quickCreate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAttributes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobAttributeIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestyCleaningStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobAttributeIds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attribute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'purchase' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stocktake' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StocktakeTaskFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetTypes' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareAttributes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareJobHistory' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareDeploymentHistory' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutomationFormQuery, AutomationFormQueryVariables>;
export const ContactTypesPreset_ListFiltersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactTypesPreset_ListFilters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'preset' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preset' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'preset' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTypesPreset_ListFiltersQuery,
  ContactTypesPreset_ListFiltersQueryVariables
>;
export const UpdateDeploymentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDeployment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'images' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'String' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDeployment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'images' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'images' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDeploymentMutation,
  UpdateDeploymentMutationVariables
>;
export const GuestySetupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GuestySetup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'integrationToken' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestySetup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationToken' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'integrationToken' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GuestySetupMutation, GuestySetupMutationVariables>;
export const ItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Items' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'Status' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'inConfig' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inConfig' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'inConfig' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'itemData' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'itemData' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Item' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'skuPrefix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'images' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activeSkus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVariants' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttributeFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skus' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: '_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'images' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'variant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'variantTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'values' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ItemsQuery, ItemsQueryVariables>;
export const CreateJobTemplateFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateJobTemplateForm' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrations' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateJobTemplateFormQuery,
  CreateJobTemplateFormQueryVariables
>;
export const EditJobFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EditJobForm' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrations' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'StringValue', value: 'Site', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobTemplateFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'Active' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContactFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StocktakeTaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Stocktake' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'include' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spaces' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adjustment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newOnHand' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobTemplateFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobTemplate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStarter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'behavior' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quickCreate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colour' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAttributes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobAttributeIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestyCleaningStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobAttributeIds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attribute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'purchase' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stocktake' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StocktakeTaskFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spaces' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetTypes' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'allow' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareAttributes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareJobHistory' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shareDeploymentHistory' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContactFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Contact' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationship' } },
          { kind: 'Field', name: { kind: 'Name', value: 'image' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamMember' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditJobFormQuery, EditJobFormQueryVariables>;
export const JobCalendarEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobCalendarEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobCalendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobCalendarEventFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobCalendarEventFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobCalendarEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'end' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cancelled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduleStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleEnd' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartTime' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndTime' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobCalendarEventsQuery,
  JobCalendarEventsQueryVariables
>;
export const JobStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'job' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isScheduled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobStatusQuery, JobStatusQueryVariables>;
export const ListJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'scheduled' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dateAfter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DateTime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dateBefore' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DateTime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'JobStatus' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locationName' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locationOwnerId' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locationAttributes' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AttributeInput' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assignee' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'included' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ofType' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tags' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'assignees' },
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobBoard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduled' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'scheduled' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleFrom' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dateAfter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleTo' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dateBefore' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locationName' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationOwnerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locationOwnerId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationAttributes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locationAttributes' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assignee' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'assignee' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'included' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'included' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ofType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ofType' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tags' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tags' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'JobCalendarEvent' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hidden' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'JobCalendarEventFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Job' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduleStart' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduleEnd' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledStartStrict' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledStartDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledStartTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledEndStrict' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledEndDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledEndTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeZone' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobTags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colour' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'Site' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'licensor' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignees' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupied' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'checkIn' },
                              name: { kind: 'Name', value: 'start' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'checkOut' },
                              name: { kind: 'Name', value: 'end' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prevCheckOut' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'checkIn' },
                              name: { kind: 'Name', value: 'start' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'checkOut' },
                              name: { kind: 'Name', value: 'end' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextCheckIn' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'checkIn' },
                              name: { kind: 'Name', value: 'start' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'checkOut' },
                              name: { kind: 'Name', value: 'end' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobCalendarEventFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobCalendarEvent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'end' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cancelled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduleStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleEnd' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledStartTime' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndStrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledEndTime' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListJobsQuery, ListJobsQueryVariables>;
export const SitesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Sites' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sites' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeLocations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SitesQuery, SitesQueryVariables>;
export const SiteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Site' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrations' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'site' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licensor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultSource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AttributeFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'integrationAttributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'images' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'airbnbCalendar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'provider' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'syncedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'airbnbDefaultCheckIn' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'airbnbDefaultCheckOut' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'homhero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttributeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ext' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalFilename' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteQuery, SiteQueryVariables>;
export const SiteFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SiteForm' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'integrations' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homheroAreas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteFormQuery, SiteFormQueryVariables>;
